import QRCode from 'qrcode'
const transactionForms = require('../../config.js').configs.transactionForms;

export const invoiceTemplateMixin =  {
//   props:['data', 'preview', 'isEditable', 'editParty', 'editBusiness', 'editLogo', 'editTransactionFields', 'editPrintField', 'editUpiDetails', 'themeColor', 'invoiceFor', 'headersLength', 'calculateZoomPercent', 'bizOpsLogo'],
props:['data', 'preview', 'isEditable', 'editParty', 'editBusiness', 'editLogo', 'editTransactionFields', 'editPrintField', 'themeColor', 'headersLength', 'calculateZoomPercent', 'bizOpsLogo', 'openToggleOptions', 'gstColumnType'],
  data(){
    return{
      billingAddress:null,
      partyPhoneBilling:null,
      partyPhoneShipping:null,
      shippingAddress:null,
      otherFields:[],
      headers:[],
      items:[],
      summary:{"totalTax":0},
      addOnsTotal:[],
      gstAddOnsTotal:[],
      qtyTotal:null,
      primaryQtyTotal:null,
      secondaryQtyTotal:null,
      netTotal:0,
      isHsn:false,
      isMrp:false,
      isPacking:false,
      // header:null,
      // terms:null,
      // bankDetails:null,
      // signatory:null,
      // subtitle:null,
      // billingLabel:null,
      // shippingLabel:null,
      header:{data:null, fieldId:null, showInPrintOut:true},
      terms:{data:null, fieldId:null, showInPrintOut:true},
      printNote:{data:null, fieldId:null, showInPrintOut:true},
      bankDetails:{data:null, fieldId:null, showInPrintOut:true},
      signatory:{data:null, fieldId:null, showInPrintOut:true},
      subtitle:{data:null, fieldId:null, showInPrintOut:true},
      billingLabel:{data:null, fieldId:null, showInPrintOut:true},
      shippingLabel:{data:null, fieldId:null, showInPrintOut:true},
      logoField:{data:null, fieldId:null, showInPrintOut:true},
      upiDetailField:{data:null, fieldId:null, showInPrintOut:true},
      brandLogo:{showInPrintOut:true},
      customerSignature:{showInPrintOut:true},

      description:{showInPrintOut:true},
      itemDescription:{showInPrintOut:true},
      brand:{showInPrintOut:false},
      company:{showInPrintOut:false},
      category:{showInPrintOut:false},
      // printDetails:null,
      isRef:false,
      paymentQrCodeUrl:null,
      dataLoaded:false,
      hasNilRatedItems:false,
      gridClassValue:0,
      hasHsnSummary:false,
      hsnSummary:{headers:[{id:"taxableValue", "name":"Taxable Value"}], items:[], footers:[]},
      footerSectionValue:1,
      hasBottomNote:false,
      bottomNoteValue:null,
      hasTaxableColumn:false,
      prescriberDetails:null,
      referrerDetails:null,
      gstColumnTypeValue:2,
      billerName:null,
      shipperName:null,
      itemDetailsArray:null,
      otherFieldsPosition:1,
      descriptionColspan:1,
      isDiscounts:false,
      itemGstPercentage:null,
      hasCessQty:false,
      hasCess:false,
      unitSummary:[],
      isWalkinCustomer:false,
      irnNumberQR:null,
      customItemFieldsTotal:null,
			partyDynamicFields: {"items":[], "title":"Party Custom Fields"},

      invoiceFieldsObj:{
        "upiDetails": {"fieldId":"upiDetails", "sectionName":"UPI Details", "status":true, "groupName":"businessFields", "defaultStatus":true},
        "businessLogo": {"fieldId":"businessLogo", "sectionName":"Business Logo",  "status":true, "groupName":"businessFields", "defaultStatus":true},

        "tableColSrNo": {"fieldId":"tableColSrNo", "defaultSectionName":"#", "sectionName":"#",  "status":true, "groupName":"Item", "defaultStatus":true, "tableColumn":true},

        // "itemName": {"fieldId":"itemName", "sectionName":"Item Name",  "status":true, "groupName":"Item", "defaultStatus":true},
        "tableColDescription": {"fieldId":"tableColDescription", "defaultSectionName":"Description", "sectionName":"Description",  "status":true, "groupName":"Item", "defaultStatus":true, "tableColumn":true},
        "tableColItemName": {"fieldId":"tableColItemName", "defaultSectionName":"Item Name", "sectionName":"Item Name",  "status":true, "groupName":"Item", "defaultStatus":true, "tableColumn":true, "defaultOrderNumber":1, "orderNumber":1, "itemField":true, "isBold":false},
        "additionalItemName": {"fieldId":"additionalItemName", "sectionName":"Additional Item Name",  "status":false, "groupName":"Item", "defaultStatus":false},
        "itemDescription": {"fieldId":"itemDescription", "sectionName":"Item Description",  "status":true, "groupName":"Item", "defaultStatus":true},
        "brand": {"fieldId":"brand", "sectionName":"Brand",  "status":false, "groupName":"Item", "defaultStatus":false},
        "company": {"fieldId":"company", "sectionName":"Company",  "status":false, "groupName":"Item", "defaultStatus":false},
        "category": {"fieldId":"category", "sectionName":"Category",  "status":false, "groupName":"Item", "defaultStatus":false},
        "itemNote": {"fieldId":"itemNote", "sectionName":"Item Note",  "status":true, "groupName":"Item", "defaultStatus":true},
        "productCode": {"fieldId":"productCode", "sectionName":"Item Code",  "status":false, "groupName":"Item", "defaultStatus":false},

            "amountInWords": {"fieldId":"amountInWords", "sectionName":"Amount in words",  "status":true, "groupName":"InvoiceSection", "defaultStatus":true},
        "taxAndTotal": {"fieldId":"taxAndTotal", "sectionName":"Tax & Total",  "status":true, "groupName":"InvoiceSection", "defaultStatus":true},

        "hsnSummary": {"fieldId":"hsnSummary", "sectionName":"HSN Summary",  "status":false, "groupName":"InvoiceSection", "defaultStatus":false},

        "tableColItemDescription": {"fieldId":"tableColItemDescription", "sectionName":"Item Description",  "status":true, "groupName":"InvoiceTable", "defaultStatus":true, "defaultOrderNumber":2, "orderNumber":2, "itemField":true},
        "tableColItemNote": {"fieldId":"tableColItemNote", "sectionName":"Item Note",  "status":true, "groupName":"InvoiceTable", "defaultStatus":true, "defaultOrderNumber":3, "orderNumber":3, "itemField":true},
        "tableColBrand": {"fieldId":"tableColBrand", "sectionName":"Brand",  "status":false, "groupName":"InvoiceTable", "defaultStatus":false, "defaultOrderNumber":4, "orderNumber":4, "itemField":true},
        "tableColCompany": {"fieldId":"tableColCompany", "sectionName":"Company",  "status":false, "groupName":"InvoiceTable", "defaultStatus":false, "defaultOrderNumber":5, "orderNumber":5, "itemField":true},
        "tableColCategory": {"fieldId":"tableColCategory", "sectionName":"Category",  "status":false, "groupName":"InvoiceTable", "defaultStatus":false, "defaultOrderNumber":6, "orderNumber":6, "itemField":true},
        "tableColProductCode": {"fieldId":"tableColProductCode", "sectionName":"Item Code",  "status":false, "groupName":"InvoiceTable", "defaultStatus":false, "defaultOrderNumber":7, "orderNumber":7, "itemField":true},
        "tableColQty": {"fieldId":"tableColQty", "defaultSectionName":"Qty", "sectionName":"Qty",  "status":true, "groupName":"InvoiceTable", "defaultStatus":true, "tableColumn":true},
        "tableColUnit": {"fieldId":"tableColUnit", "defaultSectionName":"Unit", "sectionName":"Unit",  "status":true, "groupName":"InvoiceTable", "defaultStatus":true, "tableColumn":true},
        "tableColMrp": {"fieldId":"tableColMrp", "defaultSectionName":"MRP", "sectionName":"MRP",  "status":true, "groupName":"InvoiceTable", "defaultStatus":true, "tableColumn":true},
        "tableColRate": {"fieldId":"tableColRate", "defaultSectionName":"Rate", "sectionName":"Rate",  "status":true, "groupName":"InvoiceTable", "defaultStatus":true, "tableColumn":true},
        "tableColSummaryBalance": {"fieldId":"tableColSummaryBalance", "defaultSectionName":"Remaining Amount", "sectionName":"Remaining Amount",  "status":true, "groupName":"InvoiceTable", "defaultStatus":true, "tableColumn":true},
        "tableColGST": {"fieldId":"tableColGST", "sectionName":"GST",  "status":true, "groupName":"InvoiceTable", "defaultStatus":true},
        "tableColTaxableValue": {"fieldId":"tableColTaxableValue", "sectionName":"Taxable Value",  "status":true, "groupName":"InvoiceTable", "defaultStatus":true},
        "tableColDiscount": {"fieldId":"tableColDiscount", "sectionName":"Discount",  "status":true, "groupName":"InvoiceTable", "defaultStatus":true, "defaultOptionFlag":1, "optionFlag":1},
        "tableColTotal": {"fieldId":"tableColTotal", "defaultSectionName":"Total", "sectionName":"Total",  "status":true, "groupName":"InvoiceTable", "defaultStatus":true, "tableColumn":true},
        "tableColTaxableValue2": {"fieldId":"tableColTaxableValue2", "defaultSectionName":"Taxable Value", "sectionName":"Always Show Taxable Value",  "status":false, "groupName":"InvoiceTable", "defaultStatus":false, "tableColumn":true},

        "tableColPrimaryQty": {"fieldId":"tableColPrimaryQty", "defaultSectionName":"Primary Qty", "sectionName":"Primary Qty",  "status":false, "groupName":"InvoiceTable", "defaultStatus":false, "tableColumn":true},
        "tableColSecondaryQty": {"fieldId":"tableColSecondaryQty", "defaultSectionName":"Secondary Qty", "sectionName":"Secondary Qty",  "status":false, "groupName":"InvoiceTable", "defaultStatus":false, "tableColumn":true},
        "tableColTaxableRate": {"fieldId":"tableColTaxableRate", "defaultSectionName":"Taxable Rate", "sectionName":"Taxable Rate",  "status":false, "groupName":"InvoiceTable", "defaultStatus":false, "tableColumn":true},

        "header": {"fieldId":"header", "sectionName":"header", "status":true, "groupName":"PrintField", "defaultStatus":true},
        "terms": {"fieldId":"terms", "sectionName":"terms",  "status":true, "groupName":"PrintField", "defaultStatus":true},
        "bankDetails": {"fieldId":"bankDetails", "sectionName":"bankDetails", "status":true, "groupName":"PrintField", "defaultStatus":true},
        "signatory": {"fieldId":"signatory", "sectionName":"signatory", "status":true, "groupName":"PrintField", "defaultStatus":true},
        "subtitle": {"fieldId":"subtitle", "sectionName":"subtitle", "status":true, "groupName":"PrintField", "defaultStatus":true},
        "billingLabel": {"fieldId":"billingLabel", "sectionName":"billingLabel", "status":true, "groupName":"PrintField", "defaultStatus":true},
        "shippingLabel": {"fieldId":"shippingLabel", "sectionName":"shippingLabel", "status":true, "groupName":"PrintField", "defaultStatus":true},
        "printNote": {"fieldId":"printNote", "sectionName":"printNote", "status":true, "groupName":"PrintField",  "defaultStatus":true, "value":null},
        "bottomNote": {"fieldId":"bottomNote", "sectionName":"bottomNote", "status":false, "groupName":"PrintField",  "defaultStatus":false, "value":null},
        "hidePaymentInfo": {"fieldId":"hidePaymentInfo", "sectionName":"hidePaymentInfo", "status":false, "groupName":"PrintField",  "defaultStatus":false, "value":null},
        "hideBaseTransactionNumber": {"fieldId":"hideBaseTransactionNumber", "sectionName":"hideBaseTransactionNumber", "status":false, "groupName":"PrintField",  "defaultStatus":false, "value":null},
        "itemCustomFieldTotal": {"fieldId":"itemCustomFieldTotal", "sectionName":"itemCustomFieldTotal", "status":false, "groupName":"PrintField",  "defaultStatus":false, "value":null},
        "customerSignature": {"fieldId":"customerSignature", "sectionName":"Customer Signature", "status":true, "groupName":"PrintField", "defaultStatus":true},

        "ebc863d6-6954-b70a-b7fa-7a22fb3168f1": {"fieldId":"ebc863d6-6954-b70a-b7fa-7a22fb3168f1", "sectionName":"PO No.", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "86723266-62de-4aac-9511-89743e6b4b7a": {"fieldId":"86723266-62de-4aac-9511-89743e6b4b7a", "sectionName":"PO Date", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "402b1cb0-b900-458d-bdf6-f0f252b08693": {"fieldId":"402b1cb0-b900-458d-bdf6-f0f252b08693", "sectionName":"PO Receipt Date", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "f35e1fe8-88b9-446d-a215-96cc52676298": {"fieldId":"f35e1fe8-88b9-446d-a215-96cc52676298", "sectionName":"Country of Supply", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "5e2bd992-9a8f-4ee0-989c-4ee9d1816f52": {"fieldId":"5e2bd992-9a8f-4ee0-989c-4ee9d1816f52", "sectionName":"Shipping Billing No.", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "8132d938-4d36-4571-a919-08e1caf6891a": {"fieldId":"8132d938-4d36-4571-a919-08e1caf6891a", "sectionName":"Shipping Billing Date", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "5419d2e4-c754-4710-9777-aad716c1b285": {"fieldId":"5419d2e4-c754-4710-9777-aad716c1b285", "sectionName":"Shipping Port Code", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "7f0aca99-cabd-4b72-b282-0788e489ec38": {"fieldId":"7f0aca99-cabd-4b72-b282-0788e489ec38", "sectionName":"Type of Import", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "1747e2de-dac2-4b89-939f-ae36c3bea9ba": {"fieldId":"1747e2de-dac2-4b89-939f-ae36c3bea9ba", "sectionName":"Bill of Entry No", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "03e70fca-bb56-4758-918a-eae7aafa57f8": {"fieldId":"03e70fca-bb56-4758-918a-eae7aafa57f8", "sectionName":"Bill of Entry Date", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "e0c98224-f5c1-431f-a7a4-b093e9b1194a": {"fieldId":"e0c98224-f5c1-431f-a7a4-b093e9b1194a", "sectionName":"Bill of Entry Port Code", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "7382995c-7c69-4efc-852c-c33bee50075b": {"fieldId":"7382995c-7c69-4efc-852c-c33bee50075b", "sectionName":"Bilty No.", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "7b0cb0f9-30ab-4996-8de7-49133880e61d": {"fieldId":"7b0cb0f9-30ab-4996-8de7-49133880e61d", "sectionName":"Bilty Date", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "452bc92a-fcdc-15ec-4cf7-a1ed93b2c4e2": {"fieldId":"452bc92a-fcdc-15ec-4cf7-a1ed93b2c4e2", "sectionName":"Mode", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "2fd5218f-3060-60ea-177c-d5f36d6f2233": {"fieldId":"2fd5218f-3060-60ea-177c-d5f36d6f2233", "sectionName":"Transporter", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "b549972a-6a89-cf47-c33d-570b20422b87": {"fieldId":"b549972a-6a89-cf47-c33d-570b20422b87", "sectionName":"LR/CR/RR No.", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "f64f89cd-4fa4-c201-f305-f0b367630a0f": {"fieldId":"f64f89cd-4fa4-c201-f305-f0b367630a0f", "sectionName":"Vehicle No.", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "931b5e6a-f65f-7da7-739b-97da6f2ae5ce": {"fieldId":"931b5e6a-f65f-7da7-739b-97da6f2ae5ce", "sectionName":"E-Way Bill No", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "7398d416-398a-8ba8-09c5-e80d682f0f86": {"fieldId":"7398d416-398a-8ba8-09c5-e80d682f0f86", "sectionName":"E-Way Bill Date", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "ea0e195d-d26d-ed9a-917a-c3875b0ffc18": {"fieldId":"ea0e195d-d26d-ed9a-917a-c3875b0ffc18", "sectionName":"Distance (In KM)", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "733d2d3d-0e28-0c43-64c3-b3c6a183b24f": {"fieldId":"733d2d3d-0e28-0c43-64c3-b3c6a183b24f", "sectionName":"Sub Type", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "4d48c812-c0a9-4067-1d5f-5623034329d1": {"fieldId":"4d48c812-c0a9-4067-1d5f-5623034329d1", "sectionName":"Document Type", "status":true, "groupName":"OtherField", "defaultStatus":true},
        "48ca6b36-1c71-42b5-8450-acb83bcb82dd": {"fieldId":"48ca6b36-1c71-42b5-8450-acb83bcb82dd", "sectionName":"Status of E-Way Bill", "status":true, "groupName":"OtherField", "defaultStatus":true},

        "fontSize": {"fieldId":"fontSize", "sectionName":"Font Size", "status":true, "groupName":"Formatting", "defaultStatus":true, "value":"normal"},
      
        "itemDetailsAlignment": {"fieldId":"itemDetailsAlignment", "sectionName":"Item details in single line", "status":false, "groupName":"settings", "defaultStatus":false},
      
        "logoLeftMargin": {"fieldId":"logoLeftMargin", "sectionName":"Logo Left Margin", "status":true, "groupName":"Formatting", "defaultStatus":true, "value":null},
        "autoColumnsWidth": {"fieldId":"autoColumnsWidth", "sectionName":"Auto Columns Width", "status":false, "groupName":"Formatting", "defaultStatus":false, "value":false},
        "itemRowBorder": {"fieldId":"itemRowBorder", "sectionName":"Item Row Border", "status":false, "groupName":"Formatting", "defaultStatus":false, "value":false},
        "logoSize": {"fieldId":"logoSize", "sectionName":"Logo Size", "status":true, "groupName":"Formatting", "defaultStatus":true, "value":"normal"},
      
        "pageTopMargin": {"fieldId":"pageTopMargin", "sectionName":"Page Top Margin", "status":true, "groupName":"Formatting", "defaultStatus":true, "value":null},
				"pageBottomMargin": {"fieldId":"pageBottomMargin", "sectionName":"Page Bottom Margin", "status":true, "groupName":"Formatting", "defaultStatus":true, "value":null},
      }
    }
  },
  methods:{

    showHideHeader: function(headerId){
      if(this.isEditable){
        return true;
      }
      if(headerId == 'tableColTaxableValue' && this.invoiceFieldsObj['tableColTaxableValue2'].status){
				return true;
			}
      else if(this.invoiceFieldsObj[headerId]){
        return this.invoiceFieldsObj[headerId].status;
      }
      else{
        return true;
      }
    },

    fadeHeaderOpacity: function(headerId){
			if(headerId == 'tableColTaxableValue'){
				return this.invoiceFieldsObj.tableColTaxableValue2.status || this.invoiceFieldsObj.tableColTaxableValue.status ? false : true;
			}
			else if(this.invoiceFieldsObj[headerId] && !this.invoiceFieldsObj[headerId].status){
				return true;
			}	
			else{
				return false;
			}
		},

    fn_getTransactionTitle: function(transactionListId){
      for(let i=0; i<transactionForms.length; i++){
        if(transactionForms[i].id == transactionListId){
          if(transactionListId == '10005' && this.$root.TransactionSettings.estimatePrintTitle){
            return this.$root.TransactionSettings.estimatePrintTitle;
          }
          else{
            return transactionForms[i].title;
          }
        }
          // if(transactionForms[i].id == transactionListId){
          //     return transactionForms[i].title;
          // }
      }
    },

    fn_generateQrCode: function(){
      let self = this;
      let url = "upi://pay?pa="+this.$root.CurrentBusiness.UpiID+"&pn="+this.$root.CurrentBusiness.UPIName;

      if(this.data.transactionDetails.onCredit){
        url = "upi://pay?pa="+this.$root.CurrentBusiness.UpiID+"&pn="+this.$root.CurrentBusiness.UPIName+"&am="+this.data.transactionDetails.onCredit;
      }
      QRCode.toDataURL(url, {margin:0})
        .then(url => {
          console.log(url);
          self.paymentQrCodeUrl = url;
        })
        .catch(err => {
          console.error(err)
      })
    },

    fn_generate_irnQR: function(){
      let self = this;
      // let url = "upi://pay?pa="+this.$root.CurrentBusiness.UpiID+"&pn="+this.$root.CurrentBusiness.UPIName;

      QRCode.toDataURL(this.data.transactionDetails.additionalData.eInvoiceDetails.irnNumber, {margin:0,width:200})
        .then(url => {
          console.log(url);
          self.irnNumberQR = url;
        })
        .catch(err => {
          console.error(err)
      })
    },

    fn_showInvoiceForText: function(){
        if(this.$route.query && this.$route.query.invoiceFor && this.$route.query.invoiceFor!='Standard'){
            return this.$route.query.invoiceFor;
        }
        // else if(this.$parent.$parent.invoiceForText && this.$parent.$parent.invoiceForText!='Standard'){
        //     return this.$parent.$parent.invoiceForText;
        // }
        else{
            return false;
        }
    },

    // fn_getInvoiceType: function(){
    //  let invoiceTypeText = null;
    //  switch (this.$route.query.invoiceFor) {
    //    case 1:
    //        invoiceTypeText = "Original For Recipient";
    //          break;
    //      case 2:
    //        invoiceTypeText = "Duplicate For Transporter";
    //          break;
    //      case 3:
    //        invoiceTypeText = "Duplicate For Supplier";
    //          break;
    //      case 4:
    //        invoiceTypeText = "Triplicate For Supplier";
    //          break;
    //      default:
    //        invoiceTypeText = "Original For Recipient";
    //  }
    //  return invoiceTypeText;
    // },

    fn_getDeviceWidth: function(){
      return window.innerWidth;
    },

    fn_editPrintField(fieldId, type){
        this.editPrintField ? this.editPrintField(fieldId, type) : '';
    },

    // fn_editUpiDetails(){
    //   if(this.isEditable){
    //     this.$router.push({"path":"/settings/payment/upi/new", "query":{"edit":1}});
    //   }
    // },

    fn_editUpiDetails(){
        if(this.isEditable){
            // this.$router.push({"path":"/settings/payment/upi/new", "query":{"edit":1}});	
            this.$eventHub.$emit('upidetails');
            // this.$refs['ref_dialogPayment'].openDialogWeb();
        }
    },

    fn_editParty(type){
        if(this.editParty){
            if(this.data.transactionDetails.transactionListId != 20005 || (type != 'expense' && this.data.transactionDetails.partyDetails.partyName)){
            this.editParty();
            }
        }
      // this.editParty ? this.editParty() : '';
    },

    fn_editBusiness(){
        this.editBusiness ? this.editBusiness() : '';
    },

    fn_editLogo(){
        this.editLogo ? this.editLogo() : '';
    },

    fn_openToggleOptions(descriptionObj, itemDescriptionObj, brandObj, categoryObj, companyObj){
      if(!this.isEditable){
        return;
      }
      
      if(this.$root.appVersion < 109){
        this.$eventHub.$emit('UpdateMobileApp');
        return;
      }

      this.openToggleOptions ? this.openToggleOptions(descriptionObj, itemDescriptionObj, brandObj, categoryObj, companyObj) : '';
    },

    fn_init: function(templateNo, calculateZoomPercent, callback, fieldObjTemp){
      if(this.$route.name == "invoicePreviewSettings"){
        this.dataLoaded = true;
      }

      if(this.data.transactionDetails && this.data.transactionDetails.isCreditDebitNote){
        if(this.data.transactionDetails.transactionListId == 10004){
          this.data.transactionDetails.invoiceTitle = 'Credit Note';
        }
        else{
          this.data.transactionDetails.invoiceTitle = 'Debit Note';
        }
      }

      // packing obj
      if(this.$root.TransactionSettings.showPacking){
        let packingLabel = this.$root.TransactionSettings.packingLabel ? this.$root.TransactionSettings.packingLabel : 'Pack Qty'; 
        let packingConfigObj = {
          "fieldId":"tableColPacking",  
          "sectionName":packingLabel, 
          "status":true, 
          "groupName":"InvoiceTable", 
          "defaultStatus":true
        }
        this.invoiceFieldsObj['tableColPacking'] = packingConfigObj;
      }

      // creating dynamic fields invoice obj if existing any
      if(this.data.transactionDetails.otherDetails.transactionFields && this.data.transactionDetails.otherDetails.transactionFields.length){
        for(let i=0; i<this.data.transactionDetails.otherDetails.transactionFields.length; i++){
          let otField = this.data.transactionDetails.otherDetails.transactionFields[i];
          if(!this.invoiceFieldsObj[otField.fieldId]){
            let obj = {"fieldId":otField.fieldId, "sectionName":otField.fieldName, "status":true, "groupName":"OtherField", "defaultStatus":true};
            this.invoiceFieldsObj[otField.fieldId] = obj;
          }
        }
      }

      let configItems = null;

      if(localStorage.getItem("template_settings")){
        let dataObj = JSON.parse(localStorage.getItem("template_settings"));
        configItems = dataObj.configItems && dataObj.configItems.length ? dataObj.configItems : null;
      }
      else if(this.data && this.data.templateSettings && this.data.templateSettings.visibilityConfig){
        configItems = JSON.parse(this.data.templateSettings.visibilityConfig);
      }

      if(configItems && configItems.length){

        // check if custom item field and adding to invoiceFieldsObj
        let customItemsConfigs = configItems.filter(cItem=>{
          return cItem.fieldId.indexOf('item_') != -1;
        })

        if(customItemsConfigs && customItemsConfigs.length){

          for(let i=0; i<customItemsConfigs.length; i++){
            
            let obj = {};
            obj.fieldId = customItemsConfigs[i].fieldId;
            obj.sectionName = customItemsConfigs[i].sectionName;
            obj.status = customItemsConfigs[i].status;
            obj.groupName = "InvoiceTable";
            obj.defaultStatus = true;
            obj.itemCustomField = true;
            obj.defaultPositionTableColumn = true;
            obj.positionTableColumn = true;
            
            if(!this.invoiceFieldsObj[obj.fieldId]){
              this.invoiceFieldsObj[obj.fieldId] = obj;
            }
          }
        }

        // check if party custom field and adding to invoiceFieldsObj
				let customPartyConfigs = configItems.filter(cItem=>{
					return cItem.fieldId.indexOf('party_') != -1;
				})

				if(customPartyConfigs && customPartyConfigs.length){

					for(let i=0; i<customPartyConfigs.length; i++){

						let obj = {};
						obj.fieldId = customPartyConfigs[i].fieldId;
						obj.fieldName = customPartyConfigs[i].fieldName;
						obj.status = customPartyConfigs[i].status;
						obj.groupName = "PartySection";
						obj.defaultStatus = true;
						obj.partyCustomField = true;
						obj.defaultPositionTableColumn = true;
						obj.positionTableColumn = true;
						
						if(!this.invoiceFieldsObj[obj.fieldId]){
							this.invoiceFieldsObj[obj.fieldId] = obj;
							this.partyDynamicFields.items.push(obj);
						}
					}
				}

        for(let i=0; i<configItems.length; i++){
          for(let [key, value] of Object.entries(this.invoiceFieldsObj)){
            if(key == configItems[i].fieldId){
              value.status = configItems[i].status;
              configItems[i].value ? value.value = configItems[i].value : '';
              configItems[i].orderNumber ? value.orderNumber = configItems[i].orderNumber : '';
              configItems[i].defaultSectionName ? value.sectionName = configItems[i].sectionName : '';
              configItems[i].defaultOptionFlag ? value.optionFlag = configItems[i].optionFlag : '';
              configItems[i].isBold ? value.isBold = configItems[i].isBold : '';
              break;
            }
          }
        }
      }

      if(fieldObjTemp && fieldObjTemp.length){
        for(let i=0; i<fieldObjTemp.length; i++){
          for(let [key, value] of Object.entries(this.invoiceFieldsObj)){
            if(key == fieldObjTemp[i].fieldId){
              value.status = fieldObjTemp[i].status;
              fieldObjTemp[i].value ? value.value = fieldObjTemp[i].value : '';
              fieldObjTemp[i].orderNumber ? value.orderNumber = fieldObjTemp[i].orderNumber : '';
              fieldObjTemp[i].defaultSectionName ? value.sectionName = fieldObjTemp[i].sectionName : '';
              break;
            }
          }
        }
      }

      this.$root.fn_getLocalItem('gstColumnType', response=>{
        let data = JSON.parse(response);
        if(data && data.LocalValue){
          this.gstColumnTypeValue = Number(data.LocalValue);
        }

        this.fn_generateQrCode();
        if(this.data.transactionDetails.partyDetails.address){
          this.fn_processAddress();
        }
        this.fn_processFields();
        if(this.data.transactionDetails.transactionItems && this.data.transactionDetails.transactionItems.length){

          // let tempOtherFieldPos = this.otherFieldsPosition;
          this.$root.fn_getLocalItem('otherFieldsPosition', response=>{
            let data = JSON.parse(response);
            if(data && data.LocalValue){
              this.otherFieldsPosition = Number(data.LocalValue);
            }

            this.fn_processTransactionItems();
            this.fn_processSummary();
          })

          // this.fn_processTransactionItems();
          // this.fn_processSummary();
        }
        else{
          // this.headers = [{"name":"#"}, {"name":"Description"}, {"name":"Amount"}];
          this.headers = [{"name":"#", "id":"tableColSrNo"}, {"name":"Description", "id":"tableColDescription"}, {"name":"Amount", "id":"tableColAmount"}];
        }

        this.fn_processSections();
        this.fn_processKeywords(templateNo);
        this.fn_processAccountFields();
      })

      

      this.$root.fn_getLocalItem('invoiceGridClassValue', response=>{
        let data = JSON.parse(response);
        if(data && data.LocalValue){
          this.gridClassValue = data.LocalValue;
        }
      });

      this.$root.fn_getLocalItem('footerSectionStyle', response=>{
        let data = JSON.parse(response);
        if(data && data.LocalValue){
          this.footerSectionValue = data.LocalValue;
        }
      });

      console.log(templateNo);
      console.log(calculateZoomPercent);
      this.dataLoaded = true;

      if(this.data.transactionDetails.transactionListItemData && this.data.transactionDetails.transactionListItemData.length && this.data.transactionDetails.transactionListItemData[0].listItemData){
        this.fn_processListItems();
      }

      // setting up signature image width and height
      // setTimeout(() => {
      //   if(this.signatory.data){
      //     let signatureImageElements = document.querySelectorAll(".bill_template .bottom-right-column .signatory img");
      //     if(signatureImageElements){
      //       let maxWidth = 120;
      //       let maxHeight = 48;
      //       let srcWidth = signatureImageElements[0].offsetWidth;
      //       let srcHeight = signatureImageElements[0].offsetHeight;
      //       let ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    
      //       let imgWidth = srcWidth * ratio;
      //       let imgHeight = srcHeight * ratio;
    
      //       signatureImageElements[0].style.width = imgWidth + "px";
      //       signatureImageElements[0].style.height = imgHeight + "px";

      //       if(signatureImageElements.length > 1){
      //         signatureImageElements[1].style.width = imgWidth + "px";
      //         signatureImageElements[1].style.height = imgHeight + "px";
      //       }
      //     }
          
      //   }
      // });

      // let self = this;
      // setTimeout(function(){ 
      //   self.fn_setTableHeaderWidth(templateNo, calculateZoomPercent);
      // },300)
      // this.fn_processPrintDetails();

      // making array of item details to sort them as per orderNumber
      this.fn_itemDetailsArray();

      if(this.data.transactionDetails.notes){
        this.data.transactionDetails.notes = this.data.transactionDetails.notes.replace(/\n/g, "<br>");
      }

      if(this.data.transactionDetails.additionalData && this.data.transactionDetails.additionalData.eInvoiceDetails && this.data.transactionDetails.additionalData.eInvoiceDetails.irnNumber){
        this.fn_generate_irnQR();
      }

      // patch fix for invoice date format in case of old format is there in settings
			// as caps mistakenly added HH:MM instead of hh:mm and it is not showing time in invoice, so changing it to correct format
			if(this.$root.TransactionSettings.invoiceDateFormat && this.$root.TransactionSettings.invoiceDateFormat == 'DD/MM/YYYY HH:MM A'){
				this.$root.TransactionSettings.invoiceDateFormat = 'DD/MM/YYYY hh:mm A';
			}
    },
    fn_itemDetailsArray: function(){
      this.itemDetailsArray = [];
      for(let [key, value] of Object.entries(this.invoiceFieldsObj)){
        console.log(key);
        if(value.orderNumber){
          this.itemDetailsArray.push(value);
        }
      }

      if(this.itemDetailsArray.length){
        this.itemDetailsArray.sort(function(a, b){
          return a.orderNumber - b.orderNumber;
        });
      }
    },
    fn_getEnabledItemsDetailsArray: function(){
      let items = [];
      items = this.itemDetailsArray.filter(arr=>{
        return arr.status;
      })
      if(this.isEditable){
        return this.itemDetailsArray;
      }
      else{
        return items;
      }
    },
    fn_processAddress: function(){
      let addresses = this.data.transactionDetails.partyDetails.address;
			for(let i=0; i<addresses.length; i++){
				if(addresses[i].groupTypeId==101 && !this.billingAddress){
					addresses[i].billerShipperName ? this.billerName = addresses[i].billerShipperName.trim() : '';
					let addressLine = addresses[i].addressLine ? addresses[i].addressLine.trim() + ', ' : '';
					let city = addresses[i].city ? addresses[i].city.trim() + ', ' : '';
					let state = addresses[i].state ? addresses[i].state + ', ' : '';
					let country = addresses[i].country && addresses[i].country != 'India' ? addresses[i].country : '';
					// let pincode = addresses[i].pincode ? ', ' + addresses[i].pincode.trim() : '';
          let countrySeparator = country ? ', ' : '';
					let pincode = addresses[i].pincode ? countrySeparator + addresses[i].pincode.trim() : '';
					this.billingAddress = addressLine + city + state + country + pincode;
					// this.billingAddress = addressLine + city + state + pincode;
					this.partyPhoneBilling = addresses[i].phone ? addresses[i].phone : null;
				}
				else if(addresses[i].groupTypeId==102 && !this.shippingAddress){
					addresses[i].billerShipperName ? this.shipperName = addresses[i].billerShipperName.trim() : '';
					let addressLine = addresses[i].addressLine ? addresses[i].addressLine.trim() + ', ' : '';
					let city = addresses[i].city ? addresses[i].city.trim() + ', ' : '';
					let state = addresses[i].state ? addresses[i].state + ', ' : '';
					let country = addresses[i].country && addresses[i].country != 'India' ? addresses[i].country : '';
					// let pincode = addresses[i].pincode ? ', ' + addresses[i].pincode.trim() : '';
          let countrySeparator = country ? ', ' : '';
					let pincode = addresses[i].pincode ? countrySeparator + addresses[i].pincode.trim() : '';
					this.shippingAddress = addressLine + city + state + country + pincode;
					// this.shippingAddress = addressLine + city + state + pincode;
					this.partyPhoneShipping = addresses[i].phone ? addresses[i].phone : null;
				}
				else if(addresses[i].groupTypeId==103 && !this.billingAddress && !this.shippingAddress){
					let addressLine = addresses[i].addressLine ? addresses[i].addressLine.trim() + ', ' : '';
					let city = addresses[i].city ? addresses[i].city.trim() + ', ' : '';
					let state = addresses[i].state ? addresses[i].state + ', ' : '';
					let country = addresses[i].country && addresses[i].country != 'India' ? addresses[i].country : '';
					// let pincode = addresses[i].pincode ? ', ' + addresses[i].pincode.trim() : '';
          let countrySeparator = country ? ', ' : '';
					let pincode = addresses[i].pincode ? countrySeparator + addresses[i].pincode.trim() : '';
					this.billingAddress = addressLine + city + state + country + pincode;
					this.shippingAddress = addressLine + city + state + country + pincode;
					// this.billingAddress = addressLine + city + state + pincode;  
					// this.shippingAddress = addressLine + city + state + pincode;
					this.partyPhoneBilling = addresses[i].phone ? addresses[i].phone : null;
					this.partyPhoneShipping = addresses[i].phone ? addresses[i].phone : null;
				}
			}
    },
    fn_processFields: function(){
      this.otherFields = [];
      
      // inserting ewayBillFields if applicable
      if(this.data.transactionDetails.roundedAmount>=50000 || this.$root.TransactionSettings.eWayBillConfigValue === 1){
        let ewayBillFields = JSON.parse(JSON.stringify(require('../../config.js').configs.transactionFields.ewayBillDetailFields))
        for(let k=0; k<ewayBillFields.length; k++){
          // this.data.templateSettings.printTemplateFields.push(ewayBillFields[k]);
          let fieldIndex = this.data.templateSettings.printTemplateFields.findIndex(item=>{
            return item.fieldId == ewayBillFields[k].fieldId;
          });

          if(fieldIndex == -1){
            this.data.templateSettings.printTemplateFields.push(ewayBillFields[k]);
          }
        }
      }

      // temporary patch for fields as need to match with applicable fields
      for(let j=0; j<this.data.transactionDetails.otherDetails.transactionFields.length; j++){
        let transactionField = this.data.transactionDetails.otherDetails.transactionFields[j];
        if(transactionField.fieldValue){
          this.otherFields.push(transactionField);
        }
      }

      // matching applicable fields
      // for(let i=0; i<this.data.templateSettings.printTemplateFields.length; i++){

      //   let printField = this.data.templateSettings.printTemplateFields[i];
      //   printField.fieldValue = null;

      //   if(printField.fieldType=='print'){
      //     printField.additionalData = JSON.parse(printField.additionalData);
      //   }

      //   for(let j=0; j<this.data.transactionDetails.otherDetails.transactionFields.length; j++){

      //     let transactionField = this.data.transactionDetails.otherDetails.transactionFields[j];
      //     if(printField.fieldId == transactionField.fieldId){
      //       printField.fieldValue = transactionField.fieldValue;
      //       this.otherFields.push(printField);
      //       break;
      //     } 
      //   }
      // }

      for(let m=0; m<this.otherFields.length; m++){
        for(let [key, value] of Object.entries(this.invoiceFieldsObj)){
          if(key == this.otherFields[m].fieldId){
            this.otherFields[m].status = value.status;
            break;
          }
        }
      }

      console.log(JSON.stringify(this.otherFields));
    },

    // fn_processFields: function(){
    //  this.otherFields = [];
    //  for(let i=0; i<this.data.transactionDetails.otherDetails.transactionSections.length; i++){
    //    let sectionObj = {};
    //    sectionObj.sectionId = this.data.transactionDetails.otherDetails.transactionSections[i].sectionId;
    //    sectionObj.sectionName = this.data.transactionDetails.otherDetails.transactionSections[i].sectionName;
    //    sectionObj.fields = [];
    //    for(let k=0; k<this.data.transactionDetails.otherDetails.transactionFields.length; k++){

    //      for(let j=0; j<this.data.templateSettings.printTemplateFields.length; j++){

    //        let field = this.data.transactionDetails.otherDetails.transactionFields[k];
    //        if(sectionObj.sectionId == field.sectionId && this.data.templateSettings.printTemplateFields[j].printTemplateFieldId == field.fieldId){
    //          let fieldObj = {};
    //          fieldObj.fieldName = field.fieldName;
    //          fieldObj.fieldValue = field.fieldValue;
    //          sectionObj.fields.push(fieldObj);
    //          break;
    //        }

    //      }
          
    //    }
        

    //    this.otherFields.push(sectionObj);
    //  }

    //  console.log(JSON.stringify(this.otherFields));
    // },
    fn_processTransactionItems: function(){
      // this.headers = [{"name":"#"}, {"name":"Description"}, {"name":"HSN/SAC"}, {"name":"Qty"}, {"name":"Unit"}, {"name":"MRP"}, {"name":"Rate/Unit"}]
      this.headers = [{"name":"#", "id":"tableColSrNo"}, {"name":"Description", "id":"tableColDescription"}, {"name":"HSN/SAC", "id":"tableColHsn"}, {"name":"Qty", "id":"tableColQty"}, {"name":"Unit", "id":"tableColUnit"}, {"name":"MRP", "id":"tableColMrp"}, {"name":"Rate/Unit", "id":"tableColRate"}, {"name":"Primary Qty", "id":"tableColPrimaryQty"}, {"name":"Secondary Qty", "id":"tableColSecondaryQty"}]
      
      if(this.$root.TransactionSettings.showPacking){
        let packingLabel = this.$root.TransactionSettings.packingLabel ? this.$root.TransactionSettings.packingLabel : 'Pack Qty'; 
        this.headers.push({"name":packingLabel, "id":"tableColPacking"});
      }

      this.items = [];
      this.isHsn = false;
      this.isMrp = false;
      this.isPacking = false;
      let qtyTotal = 0;
      let unitId = null;
      let isSimilarUnit = true;
      let isSecondaryUnit = false;

      let primaryQtyTotal = 0;
      let secondaryQtyTotal = 0;
      let primaryUnitName = null;
      let secondaryUnitName = null;

      this.itemGstPercentage = null;
      // let isSimilarGst = true;

      // let hasSeries = false;
      let hasBatch = false;
      // let isColsPushed = false;
      let hasBatchNumber = false;
      let hasBatchSize = false;
      let hasMfgDate = false;
      let hasExpDate = false;
      let unitArray = [];
      // let hasPurchaseRate = false;

      // let batchNumberPushed = false;
      // let batchSizePushed = false;
      // let mfgDatePushed = false;
      // let expDatePushed = false;
      // let purchaseRatePushed = false;

      // running loop on items to know batch fields
      for(let i=0; i<this.data.transactionDetails.transactionItems.length; i++){
        let item = this.data.transactionDetails.transactionItems[i].cols;

        // checking if item contains cess addon
        let cessAddon = item.addOns.findIndex(addon=>{return addon.name == 'CESS' && !addon.cessValueOnQuantity})
        cessAddon != -1 ? this.hasCess = true : '';

        // changing new line to br tag
        if(this.data.transactionDetails.transactionItems[i].itemDescription){
          this.data.transactionDetails.transactionItems[i].itemDescription = this.data.transactionDetails.transactionItems[i].itemDescription.replace(/\n/g, "<br>")
        }

        if(this.data.transactionDetails.transactionItems[i].description){
          this.data.transactionDetails.transactionItems[i].description = this.data.transactionDetails.transactionItems[i].description.replace(/\n/g, "<br>");
        }

        item.hasBatch = false;
        item.hasSeries = false;
        if(item.productBatches && item.productBatches.length){
          // item.hasBatch = true;
          // let itemObj = {};
          // itemObj.batches = [];
          // itemObj.field1 = [];
          // itemObj.field2 = [];
          // itemObj.field3 = [];
          for(let i=0; i<item.productBatches.length; i++){
            let field = item.productBatches[i];
            // if(field.field1 || field.field2 || field.field3){
            // 	item.hasSeries = true;
            // 	field.field1 ? itemObj.field1.push(field.field1) : '';
            // 	field.field2 ? itemObj.field2.push(field.field2) : '';
            // 	field.field3 ? itemObj.field3.push(field.field3) : '';
            // }
    
            if(field.batchNumber || field.batchMRP || field.purchaseRate || field.batchSize || field.mfgDate || field.expDate){
              hasBatch = true;
              item.hasBatch = true;
              field.batchNumber ? hasBatchNumber = true : '';
              field.batchSize ? hasBatchSize = true : '';
              field.mfgDate ? hasMfgDate = true : '';
              field.expDate ? hasExpDate = true : '';
            }

            if(!item.mrp && field.batchMRP){
              item.mrp = field.batchMRP;
              this.isMrp = true;
            }
          }

          // if(hasBatch){
          // 	let insertIndex = 4;
            
          // 	if(hasBatchNumber && !batchNumberPushed){
          // 		this.headers.splice(insertIndex, 0, {"name":"#Batch", "id":"batchNumber"});
          // 		insertIndex++;
          // 		batchNumberPushed = true;
          // 	}

          // 	if(hasBatchSize && !batchSizePushed){
          // 		this.headers.splice(insertIndex, 0, {"name":"Size", "id":"batchSize"});
          // 		insertIndex++;
          // 		batchSizePushed = true;
          // 	}

          // 	if(hasMfgDate && !mfgDatePushed){
          // 		this.headers.splice(insertIndex, 0, {"name":"Mfg Date", "id":"mfgDate"});
          // 		insertIndex++;
          // 		mfgDatePushed = true;
          // 	}

          // 	if(hasExpDate && !expDatePushed){
          // 		this.headers.splice(insertIndex, 0, {"name":"Exp Date", "id":"expDate"});
          // 		insertIndex++;
          // 		expDatePushed = true;
          // 	}
          // }
        }
      }

      if(hasBatch){
        let insertIndex = 4;
        
        if(hasBatchNumber){
          this.headers.splice(insertIndex, 0, {"name":"Batch#", "id":"batchNumber"});
          insertIndex++;
        }

        if(hasBatchSize){
          this.headers.splice(insertIndex, 0, {"name":"Size", "id":"batchSize"});
          insertIndex++;
        }

        if(hasMfgDate){
          this.headers.splice(insertIndex, 0, {"name":"Mfg Date", "id":"mfgDate"});
          insertIndex++;
        }

        if(hasExpDate){
          this.headers.splice(insertIndex, 0, {"name":"Exp Date", "id":"expDate"});
          insertIndex++;
        }
      }

      for(let i=0; i<this.data.transactionDetails.transactionItems.length; i++){
        let item = this.data.transactionDetails.transactionItems[i].cols;

        let cessQtyItemIndex = item.addOns.findIndex(gItem=>{return gItem.cessValueOnQuantity});

        // moving cess qty addon to last
        if(cessQtyItemIndex != -1 && cessQtyItemIndex != (item.addOns.length - 1)){
          let tempCessQtyItem = item.addOns[cessQtyItemIndex];
          item.addOns.splice(cessQtyItemIndex, 1);
          item.addOns.push(tempCessQtyItem);
        }

        // adding dummy cess addon if cess exist in any item in the bill
        let cessItemIndex = item.addOns.findIndex(gItem=>{return gItem.name=='CESS' && !gItem.cessValueOnQuantity});

        if(this.hasCess && cessQtyItemIndex != -1 && cessItemIndex == -1){
          let obj = {"addOnsId":"3450f633-87d7-4bfa-9c50-e8eca144dc82","addonGroupId":"2","cessValueOnQuantity":null,"isGst":true,"name":"CESS","percentage":null,"value":null}
          item.addOns.splice(item.addOns.length - 1, 0, obj);
        }

        let itemObj = {};
        itemObj.itemName = item.itemName;
        itemObj.hsn = item.hsn;
        itemObj.qty = item.qty;
        itemObj.unit = item.unitName;

        // if(item.secondaryUnitId && item.secondaryUnitName){
        // 	isSecondaryUnit = true;
        // }

        // let primaryQty = 0;
        // let secondaryQty = 0;

        // if(item.unitId == item.primaryUnitId){
        // 	itemObj.primaryQty = item.qty + ' ' + item.primaryUnitName;
        // 	secondaryQty = this.roundUpto2Decimals((item.qty * item.secondaryUnitPackQuantity) / item.packQuantity);
        // 	itemObj.secondaryQty = secondaryQty + ' ' + item.secondaryUnitName;

        // 	primaryQty = item.qty;
        // }
        // else{
        // 	itemObj.secondaryQty = item.qty + item.secondaryUnitName;
        // 	primaryQty = this.roundUpto2Decimals((item.qty * item.packQuantity) / item.secondaryUnitPackQuantity);
        // 	itemObj.primaryQty = primaryQty + ' ' + item.primaryUnitName;

        // 	secondaryQty = item.qty;
        // }

        // if(item.primaryUnitId){
        // 	primaryQtyTotal += primaryQty;
        // 	primaryUnitName = item.primaryUnitName;
        // }

        // if(item.secondaryUnitId){
        // 	secondaryQtyTotal += secondaryQty;
        // 	secondaryUnitName = item.secondaryUnitName;
        // }
        
        if(i>0 && unitId != item.unitId){
          isSimilarUnit = false;
        }

        // pushing units to array
        let uObj = {unitId:item.unitId, unitName:item.unitName, qty:item.qty};
        unitArray.push(uObj);

        unitId = item.unitId;
        qtyTotal += item.qty;
        itemObj.mrp = item.mrp;
        itemObj.rate = item.rate;
        itemObj.addOns = [];
        itemObj.gstAddOns = [];
        // gst addons for thermal print(for future use)
        itemObj.gstAddOnsThermalPrint = [];

        itemObj.description = this.data.transactionDetails.transactionItems[i].description;
        itemObj.itemDescription = this.data.transactionDetails.transactionItems[i].itemDescription;
        itemObj.baseTransactionNumber = this.data.transactionDetails.transactionItems[i].baseTransactionNumber;

        itemObj.brand = this.data.transactionDetails.transactionItems[i].brandName;
        itemObj.company = this.data.transactionDetails.transactionItems[i].companyName;
        itemObj.category = this.data.transactionDetails.transactionItems[i].categoryName;

        itemObj.productCode = item.productCode ? item.productCode : null;

        if(this.$root.TransactionSettings.showPacking && item.packing){
          this.isPacking = true;
          itemObj.packing = item.packing;
        }

        for(let j=0; j<item.addOns.length; j++){

          !item.rate ? item.addOns[j].value = 0 : '';
          

          
          !item.rate ? item.addOns[j].percentage = 0 : '';

          if(!item.addOns[j].isGst){
            itemObj.addOns.push(item.addOns[j]);

            let headerIndex = this.headers.findIndex(header=>{
              return header.addOnsId == item.addOns[j].addOnsId;
            })

            if(headerIndex==-1){
              let obj = {};
              obj.addOnsId = item.addOns[j].addOnsId;
              if(item.addOns[j].addonGroupId == 1){
                this.isDiscounts = true;
                obj.id = 'tableColDiscount';
              }
              else{
                obj.id = item.addOns[j].addOnsId;
              }

              obj.name = item.addOns[j].name;
              this.headers.push(obj);
            }
          }
          else{

            // if(i>0 && this.itemGstPercentage != item.addOns[j].percentage){
            // 	isSimilarGst = false;
            // }

            // this.itemGstPercentage = item.addOns[j].percentage;

            // if(!isSimilarGst){
            // 	this.itemGstPercentage = null;
            // }

            if(item.addOns[j].cessValueOnQuantity){
              item.addOns[j].addOnsId = 'cessonqty';
              item.addOns[j].value = this.roundUpto2Decimals(item.addOns[j].cessValueOnQuantity * item.qty);
            }

            // gst values for thermal-print (for future use)
            itemObj.gstAddOnsThermalPrint.push(item.addOns[j]);

            if(this.getGstColumnType == 3 || this.getGstColumnType == 4){
              if(item.addOns[j].name == 'CESS'){
                itemObj.gstAddOns.push(item.addOns[j]);
              }
              else{
                item.addOns[j].addOnsId = 'custom_gst_'+item.addOns[j].name;
                if(!itemObj.gstAddOns.length){
                  itemObj.gstAddOns.push(JSON.parse(JSON.stringify(item.addOns[j])));
                }
                else{
                  if(item.addOns[j].name != 'IGST'){
                    itemObj.gstAddOns[0].percentage = item.addOns[j].percentage + item.addOns[j].percentage;
                    itemObj.gstAddOns[0].value = item.addOns[j].value + item.addOns[j].value;
                  }
                }
              }
            }
            else{
              itemObj.gstAddOns.push(JSON.parse(JSON.stringify(item.addOns[j])));
            }
            // itemObj.gstAddOns.push(item.addOns[j]);
          }
          
        }

        if(!item.rate){
          item.taxableValue = 0;
          item.total = 0;
        }

        itemObj.taxableValue = item.taxableValue;
        itemObj.taxableRate = this.roundUpto2Decimals(item.taxableValue / item.qty);
        itemObj.total = item.netAmount;

        if(item.taxableValue){
          this.hasTaxableColumn = true;
        }

        itemObj.orderNumber = item.orderNumber;

        // item custom fields
        let itemFields = [];
        if(item.itemDetailFields && item.itemDetailFields.data && item.itemDetailFields.data.length){
          let fields = item.itemDetailFields.data[0].items;
          if(fields && fields.length){
            
            for(let i=0; i<fields.length; i++){
              if(fields[i].value){
                let headerIndex = this.headers.findIndex(header=>{
                  return header.id == 'item_' + fields[i].fieldId;
                })
    
                if(headerIndex==-1 && this.otherFieldsPosValue == 1){
                  let obj = {};
                  obj.id = 'item_' + fields[i].fieldId;
                  obj.fieldId = 'item_' + fields[i].fieldId;
                  obj.name = fields[i].displayName;
                  this.headers.splice(2, 0, obj);
                }

                let obj2 = {};
                obj2.id = 'item_' + fields[i].fieldId;
                obj2.fieldId =  'item_' + fields[i].fieldId;
                obj2.displayName = fields[i].displayName;
                obj2.fieldType = fields[i].fieldType;
                obj2.value = fields[i].value;
                itemFields.push(obj2);
              }
              
            }

            if(itemFields.length){
              itemObj.customFields = itemFields;
  
              // making invoice config obj for item custom fields
              for(let i=0; i<fields.length; i++){
                if(fields[i].value){
                  let obj = {};
                  obj.fieldId = 'item_'+fields[i].fieldId;
                  obj.sectionName = fields[i].displayName;
                  obj.status = true;
                  obj.groupName = "InvoiceTable";
                  obj.defaultStatus = true;
                  obj.itemCustomField = true;
                  obj.defaultPositionTableColumn = true;
                  obj.positionTableColumn = true;
  
                  if(this.otherFieldsPosValue == 2){
                    // custom item field position under item name 
                    // removing headers
                    let headerIndex = this.headers.findIndex(head=>{
                      return head.fieldId == obj.fieldId;
                    })
  
                    if(headerIndex != -1){
                      this.headers.splice(headerIndex, 1)
                    }
                  }
                  
                  if(!this.invoiceFieldsObj[obj.fieldId]){
                    this.invoiceFieldsObj[obj.fieldId] = obj;
                  }
                }
              }								
            }
          }

          
        }

        if(item.productBatches && item.productBatches.length){
          itemObj.field1 = [];
          itemObj.field2 = [];
          itemObj.field3 = [];
          // item.hasBatch = true;
          // itemObj.batches = [];
          // itemObj.field1 = [];
          // itemObj.field2 = [];
          // itemObj.field3 = [];
          // for(let i=0; i<item.productBatches.length; i++){
          // 	let field = item.productBatches[i];
          // 	if(field.field1 || field.field2 || field.field3){
          // 		item.hasSeries = true;
          // 		field.field1 ? itemObj.field1.push(field.field1) : '';
          // 		field.field2 ? itemObj.field2.push(field.field2) : '';
          // 		field.field3 ? itemObj.field3.push(field.field3) : '';
          // 	}
    
          // 	if(field.batchNumber || field.batchMRP || field.purchaseRate || field.batchSize || field.mfgDate || field.expDate || field.field4){
          // 		hasBatch = true;
          // 		field.batchNumber ? hasBatchNumber = true : '';
          // 		field.batchSize ? hasBatchSize = true : '';
          // 		field.mfgDate ? hasMfgDate = true : '';
          // 		field.expDate ? hasExpDate = true : '';
          // 	}
          // }

          // if(hasBatch){
          // 	let insertIndex = 4;
            
          // 	if(hasBatchNumber && !batchNumberPushed){
          // 		this.headers.splice(insertIndex, 0, {"name":"#Batch", "id":"batchNumber"});
          // 		insertIndex++;
          // 		batchNumberPushed = true;
          // 	}

          // 	if(hasBatchSize && !batchSizePushed){
          // 		this.headers.splice(insertIndex, 0, {"name":"Size", "id":"batchSize"});
          // 		insertIndex++;
          // 		batchSizePushed = true;
          // 	}

          // 	if(hasMfgDate && !mfgDatePushed){
          // 		this.headers.splice(insertIndex, 0, {"name":"Mfg Date", "id":"mfgDate"});
          // 		insertIndex++;
          // 		mfgDatePushed = true;
          // 	}

          // 	if(hasExpDate && !expDatePushed){
          // 		this.headers.splice(insertIndex, 0, {"name":"Exp Date", "id":"expDate"});
          // 		insertIndex++;
          // 		expDatePushed = true;
          // 	}
          // }

          itemObj.batchLength = item.productBatches && item.productBatches.length ? item.productBatches.length : 0;
          let itemWiseTaxableValue = itemObj.taxableValue;
          let itemWiseAddOnsValue = JSON.parse(JSON.stringify(itemObj.addOns));
          let itemWiseGstAddOnsValue = JSON.parse(JSON.stringify(itemObj.gstAddOns));
          let itemWiseTotal = itemObj.total;

          for(let i=0; i<item.productBatches.length; i++){

            let field = item.productBatches[i];
            if(field.field1 || field.field2 || field.field3){
              item.hasSeries = true;
              field.field1 ? itemObj.field1.push(field.field1) : '';
              field.field2 ? itemObj.field2.push(field.field2) : '';
              field.field3 ? itemObj.field3.push(field.field3) : '';
            }

            itemObj.field4 = [];
            if(field.field4){
              itemObj.field4.push(field.field4);
            }

            if(hasBatch){
              
              if(item.productBatches[i].qty && !item.hasSeries){
                itemObj.qty = item.productBatches[i].qty;
              }

              if(item.productBatches[i].batchNumber || hasBatchNumber){
                itemObj.batchNumber = item.productBatches[i].batchNumber ? item.productBatches[i].batchNumber : '';
              }

              if(item.productBatches[i].batchSize || hasBatchSize){
                itemObj.batchSize = item.productBatches[i].batchSize ? item.productBatches[i].batchSize : '';
                hasBatchSize = true;
              }

              if(item.productBatches[i].batchMRP){
                itemObj.mrp = item.productBatches[i].batchMRP;
              }

              if(item.productBatches[i].mfgDate || hasMfgDate){
                itemObj.mfgDate = item.productBatches[i].mfgDate ? this.$moment(new Date(item.productBatches[i].mfgDate)).format(this.$root.batchDateFormat) : '';
              }

              if(item.productBatches[i].expDate || hasExpDate){
                itemObj.expDate = item.productBatches[i].expDate ? this.$moment(new Date(item.productBatches[i].expDate)).format(this.$root.batchDateFormat) : '';
              }

              // if(item.productBatches[i].purchaseRate || hasPurchaseRate){
              // 	itemObj.purchaseRate = item.productBatches[i].purchaseRate ? item.productBatches[i].purchaseRate : '';
              // }
            }

            if(itemObj.batchLength > 1){
              itemObj.taxableValue = (itemWiseTaxableValue / item.qty) * itemObj.qty;
              
              for(let i=0; i<itemWiseAddOnsValue.length; i++){
                itemObj.addOns[i].value =  (itemWiseAddOnsValue[i].value / item.qty) * itemObj.qty
              }

              for(let i=0; i<itemWiseGstAddOnsValue.length; i++){
                itemObj.gstAddOns[i].value =  (itemWiseGstAddOnsValue[i].value / item.qty) * itemObj.qty
              }

              itemObj.total = (itemWiseTotal / item.qty) * itemObj.qty;
            }

            if(item.secondaryUnitId && item.secondaryUnitName){
              isSecondaryUnit = true;
            }

            let primaryQty = 0;
            let secondaryQty = 0;

            if(item.unitId == item.primaryUnitId){
              itemObj.primaryQty = itemObj.qty + ' ' + item.primaryUnitName;
              secondaryQty = this.roundUpto2Decimals((itemObj.qty * item.secondaryUnitPackQuantity) / item.packQuantity);
              if(item.secondaryUnitName){
                itemObj.secondaryQty = secondaryQty + ' ' + item.secondaryUnitName;
              }

              primaryQty = itemObj.qty;
            }
            else{
              if(item.secondaryUnitName){
                itemObj.secondaryQty = itemObj.qty + item.secondaryUnitName;
              }
              primaryQty = this.roundUpto2Decimals((itemObj.qty * item.packQuantity) / item.secondaryUnitPackQuantity);
              itemObj.primaryQty = primaryQty + ' ' + item.primaryUnitName;

              secondaryQty = itemObj.qty;
            }

            if(item.primaryUnitId){
              primaryQtyTotal += primaryQty;
              primaryUnitName = item.primaryUnitName;
            }

            if(item.secondaryUnitId){
              secondaryQtyTotal += secondaryQty;
              secondaryUnitName = item.secondaryUnitName;
            }

            if(item.hasBatch){
              itemObj.batchTotalTaxableValue = item.taxableValue;
              this.items.push(JSON.parse(JSON.stringify(itemObj)))
              // this.fn_calculateHsnSummary(itemObj, item.addOns);
              // this.fn_calculateHsnSummary(itemObj, itemObj.gstAddOns, item.addOns);
            }

            // item.hasBatch ? this.items.push(JSON.parse(JSON.stringify(itemObj))) : '';
          }
        }


        if(!item.hasBatch || item.hasSeries){
          if(hasBatch){
              
            // if(item.productBatches[i].qty){
            // 	itemObj.qty = item.productBatches[i].qty;
            // }

            if(hasBatchNumber){
              itemObj.batchNumber = '';
            }

            if(hasBatchSize){
              itemObj.batchSize = '';
              hasBatchSize = true;
            }

            // if(item.productBatches[i].batchMRP){
            // 	itemObj.mrp = item.productBatches[i].batchMRP;
            // }

            if(hasMfgDate){
              itemObj.mfgDate = '';
            }

            if(hasExpDate){
              itemObj.expDate = '';
            }
          }

          this.items.push(itemObj)
        }
        
        // this.items.push(itemObj);

        item.hsn && this.$root.CurrentBusiness.GSTRegistrationStatus == 1 ? this.isHsn = true : '';
        // item.mrp>=0 && this.$root.TransactionSettings.mrpWiseStock ? this.isMrp = true : '';
        item.mrp && this.$root.TransactionSettings.mrpWiseStock ? this.isMrp = true : '';

        if(!item.hasBatch){
          if(item.secondaryUnitId && item.secondaryUnitName){
              isSecondaryUnit = true;
            }

            let primaryQty = 0;
            let secondaryQty = 0;

            if(item.unitId == item.primaryUnitId){
              itemObj.primaryQty = itemObj.qty + ' ' + item.primaryUnitName;
              secondaryQty = this.roundUpto2Decimals((itemObj.qty * item.secondaryUnitPackQuantity) / item.packQuantity);
              if(item.secondaryUnitName){
                itemObj.secondaryQty = secondaryQty + ' ' + item.secondaryUnitName;
              }

              primaryQty = itemObj.qty;
            }
            else{
              if(item.secondaryUnitName){
                itemObj.secondaryQty = itemObj.qty + item.secondaryUnitName;
              }
              primaryQty = this.roundUpto2Decimals((itemObj.qty * item.packQuantity) / item.secondaryUnitPackQuantity);
              itemObj.primaryQty = primaryQty + ' ' + item.primaryUnitName;

              secondaryQty = itemObj.qty;
            }

            if(item.primaryUnitId){
              primaryQtyTotal += primaryQty;
              primaryUnitName = item.primaryUnitName;
            }

            if(item.secondaryUnitId){
              secondaryQtyTotal += secondaryQty;
              secondaryUnitName = item.secondaryUnitName;
            }
          // this.fn_calculateHsnSummary(itemObj, item.addOns);
          // this.fn_calculateHsnSummary(itemObj, itemObj.gstAddOns, item.addOns);
        }

        // removing primary and secondary unit/qty properties if not included in invoice
        if(!isSecondaryUnit || this.$root.appVersion < 253){
          delete this.invoiceFieldsObj.tableColPrimaryQty;
          delete this.invoiceFieldsObj.tableColSecondaryQty;
          let primaryIndex = this.headers.findIndex(head=>{return head.id == 'tableColPrimaryQty'})
          primaryIndex != -1 ? this.headers.splice(primaryIndex, 1) : '';
          let secondaryIndex = this.headers.findIndex(head=>{return head.id == 'tableColSecondaryQty'})
          secondaryIndex != -1 ? this.headers.splice(secondaryIndex, 1) : '';
        }

        this.fn_calculateHsnSummary(itemObj, item.addOns);
      //   let addons = item.addOns.filter(addon=>{return addon.isGst});

      //   // if(itemObj.gstAddOns && itemObj.gstAddOns.length && this.$root.CurrentBusiness.GSTRegistrationStatus == 1){
      //   if(addons && addons.length && this.$root.CurrentBusiness.GSTRegistrationStatus == 1){
      //     let obj = {};
      //     obj.hsn = item.hsn ? item.hsn : '';
      //     obj.taxableValue = itemObj.taxableValue;
      //     obj.gstAddOns =  JSON.parse(JSON.stringify(addons));
      //     // obj.gstAddOns =  JSON.parse(JSON.stringify(itemObj.gstAddOns));
      //     obj.totalTax = 0;
      //     for(let j=0; j<obj.gstAddOns.length; j++){
      //       obj.totalTax = obj.totalTax + obj.gstAddOns[j].value;

      //       let headerIndex = this.hsnSummary.headers.findIndex(header=>{
      //         return header.id === obj.gstAddOns[j].addOnsId;
      //       })

      //       if(headerIndex==-1){
      //         let hobj = {};
      //         hobj.id = obj.gstAddOns[j].addOnsId;
      //         hobj.name = obj.gstAddOns[j].name;
      //         this.hsnSummary.headers.push(hobj);
      //       }
      //     }

      //     this.hsnSummary.items.push(obj);
      //   }
      }

      let summary = [];
      if(this.hsnSummary.items.length){
        this.hsnSummary.headers.push({"id":"totalTax", "name":"Total Tax"});

        let cessColIndex = this.hsnSummary.headers.findIndex(head=>head.name == 'CESS');
        
        this.hsnSummary.items.forEach((item)=>{
          if(cessColIndex != -1){
            let cessIndex = item.gstAddOns.findIndex(gstitem=>gstitem.name == "CESS");
            if(cessIndex==-1){
              let cessObj = {};
              cessObj.name = "CESS";
              cessObj.value = 0;
              item.gstAddOns.push(cessObj);
            }
          }

          
          let itemGst = [];
          item.gstAddOns.forEach((addOn)=>{
            let obj = {};
            obj.name = addOn.name;
            obj.percentage = addOn.percentage;
            itemGst.push(obj);
          })

          let indx = -1;
          for(let a=0; a<summary.length; a++){
            let summaryGst = [];
            summary[a].gstAddOns.forEach((addOn)=>{
              let obj = {};
              obj.name = addOn.name;
              obj.percentage = addOn.percentage;
              summaryGst.push(obj);
            });
            if(summary[a].hsn == item.hsn && JSON.stringify(summaryGst) == JSON.stringify(itemGst)){
              indx = a;
              break;
            }
          }

          if(indx != -1){
            summary[indx].taxableValue = summary[indx].taxableValue + item.taxableValue;

            summary[indx].gstAddOns[0].value = summary[indx].gstAddOns[0].value + item.gstAddOns[0].value;
            if(item.gstAddOns.length > 1){
              summary[indx].gstAddOns[1].value = summary[indx].gstAddOns[1].value + item.gstAddOns[1].value;
            }

            if(item.gstAddOns.length > 2){
              summary[indx].gstAddOns[2].value = summary[indx].gstAddOns[2].value + item.gstAddOns[2].value;
            }

            summary[indx].totalTax = summary[indx].totalTax + item.totalTax;
          }
          else{
            summary.push(item);
          }
        })

        if(this.hasCess && this.hasCessQty){
          for(let m=0; m<this.hsnSummary.items.length; m++){
            let cessIndex = this.hsnSummary.items[m].gstAddOns.findIndex(gst=>{return gst.name == 'CESS' && !gst.cessValueOnQuantity});
            if(cessIndex == -1){
              let obj = {};
              obj.name = 'CESS';
              obj.value = null;
              obj.percentage = null;
              this.hsnSummary.items[m].gstAddOns.splice(this.hsnSummary.items[m].gstAddOns.length - 1, 0, obj);
            }
          }
        }
        
      }

      if(summary.length){
        // footer calculation
        let totalTaxableValue = 0;
        let taxCol1 = null;
        let taxCol2 = null;
        let taxCol3 = null;
        let taxCol4 = null;
        let totalTax = 0;
        let taxColCount = 0;
        for(let i=0; i<summary.length; i++){
          totalTaxableValue = totalTaxableValue + summary[i].taxableValue;

          for(let j=0; j<summary[i].gstAddOns.length; j++){
            if(summary[i].gstAddOns[j].name != 'CESS'){
              if(j==0){
                !taxCol1 ? taxCol1 = 0 : '';
                taxCol1 = taxCol1 + summary[i].gstAddOns[j].value;
                taxColCount = 1;
              }
              else{
                !taxCol2 ? taxCol2 = 0 : '';
                taxCol2 = taxCol2 + summary[i].gstAddOns[j].value;
                taxColCount = 2;
              }
            }
          }

          // taxCol1 = taxCol1 + summary[i].gstAddOns[0].value;

          // if(summary[i].gstAddOns.length > 1){
          //   taxCol2 = taxCol2 + summary[i].gstAddOns[1].value;
          //   // taxColCount = 2;
          //   !taxColCount || taxColCount < 3 ? taxColCount = 2 : '';
          // }

          // if(summary[i].gstAddOns.length > 2){
          //   taxCol3 = taxCol3 + summary[i].gstAddOns[2].value;
          //   taxColCount = 3;
          // }

          if(summary[i].gstAddOns.length >= 2){
            let cessTax = summary[i].gstAddOns.filter(gst=>{return gst.name == 'CESS' && !gst.cessValueOnQuantity})
            if(cessTax && cessTax.length){
              !taxCol3 ? taxCol3 = 0 : '';
              taxCol3 = taxCol3 + cessTax[0].value;
              taxColCount < 3 ? taxColCount = 3 : '';
            }

            let cessQtyTax = summary[i].gstAddOns.filter(gst=>{return gst.name == 'CESS' && gst.cessValueOnQuantity})
            if(cessQtyTax && cessQtyTax.length){
              !taxCol4 ? taxCol4 = 0 : '';
              taxCol4 = taxCol4 + cessQtyTax[0].value;

              if(taxColCount < 3){
                taxColCount = 3;
              }
              else{
                taxColCount = 4;  
              }
            }
            // taxCol3 = taxCol3 + summary[i].gstAddOns[2].value;
            // taxColCount = 3;
          }

          totalTax = totalTax + summary[i].totalTax;
        }

        this.hsnSummary.items = JSON.parse(JSON.stringify(summary));

        // if(taxColCount < 2){
        if(taxCol1 != null){
          this.hsnSummary.footers = [totalTaxableValue, taxCol1, totalTax];
        }
        // if(taxColCount==2){
        if(taxCol2 != null){
          this.hsnSummary.footers = [totalTaxableValue, taxCol1, taxCol2, totalTax];
        }
        // else if(taxColCount==3 && taxCol3){
        if(taxCol3 != null){
          this.hsnSummary.footers = [totalTaxableValue, taxCol1, taxCol2, taxCol3, totalTax];
        }
        if(taxCol4 != null){
          this.hsnSummary.footers = [totalTaxableValue, taxCol1, taxCol2, taxCol3, taxCol4, totalTax];
        }

        this.hsnSummary.footers = this.hsnSummary.footers.filter(value=>{return value !== null});
        // else if(taxColCount==4){
        // 	if(taxCol3){
        // 		this.hsnSummary.footers = [totalTaxableValue, taxCol1, taxCol2, taxCol3, taxCol4, totalTax];
        // 	}
        // 	else{
        // 		this.hsnSummary.footers = [totalTaxableValue, taxCol1, taxCol2, taxCol4, totalTax];
        // 	}
        // }

        // if(taxColCount==2){
        //   this.hsnSummary.footers = [totalTaxableValue, taxCol1, taxCol2, totalTax];
        // }
        // else if(taxColCount==3){
        //   this.hsnSummary.footers = [totalTaxableValue, taxCol1, taxCol2, taxCol3, totalTax];
        // }
        // else{
        //   this.hsnSummary.footers = [totalTaxableValue, taxCol1, totalTax];
        // }
      }

      console.log(JSON.stringify(summary));

      // sorting items as per order number
      this.items.sort(function(a, b){
          return a.orderNumber - b.orderNumber;
      });

      // this.qtyTotal = isSimilarUnit ? qtyTotal : null;
      if(isSimilarUnit){
        if(qtyTotal.toString().indexOf('.') == -1){
          this.qtyTotal = Number(qtyTotal);
        }
        else{
          this.qtyTotal = Number(qtyTotal.toFixed(3));
        }

        if(primaryQtyTotal.toString().indexOf('.') == -1){
          this.primaryQtyTotal = Number(primaryQtyTotal) + ' ' + primaryUnitName;
        }
        else{
          this.primaryQtyTotal = Number(primaryQtyTotal.toFixed(3)) + ' ' + primaryUnitName;
        }

        if(secondaryQtyTotal.toString().indexOf('.') == -1){
          this.secondaryQtyTotal = Number(secondaryQtyTotal) + ' ' + secondaryUnitName;
        }
        else{
          this.secondaryQtyTotal = Number(secondaryQtyTotal.toFixed(3)) + ' ' + secondaryUnitName;
        }
      }
      else{
        this.qtyTotal = null;
        this.primaryQtyTotal = null;
        this.secondaryQtyTotal = null;
        if(unitArray && unitArray.length){
          for(let i=0; i<unitArray.length; i++){
            let uIndex = this.unitSummary.findIndex(unit=>{return unit.unitId == unitArray[i].unitId});
            if(uIndex==-1){
              this.unitSummary.push(unitArray[i]);	
            }
            else{
              this.unitSummary[uIndex].qty += unitArray[i].qty;
            }
          }
        }
      }
      // if(isSimilarUnit){
      //   if(qtyTotal.toString().indexOf('.') == -1){
      //     this.qtyTotal = Number(qtyTotal);
      //   }
      //   else{
      //     this.qtyTotal = Number(qtyTotal.toFixed(3));
      //   }
      // }
      // else{
      //   this.qtyTotal = null;
      // }

      // this.headers.push({"name":"Taxable Value"});
      // pushing taxable rate column
			this.headers.push({"name":"Taxable Rate", "id":"tableColTaxableRate"});
      
      this.headers.push({"name":"Taxable Value", "id":"tableColTaxableValue"});
      this.hasTaxableColumn = true;

      let customFieldsTotal = [];

      for(let l=0; l<this.items.length; l++){

        let cessQtyItemIndex = this.items[l].gstAddOns.findIndex(gItem=>{return gItem.cessValueOnQuantity});

        if(cessQtyItemIndex != -1 && cessQtyItemIndex != (this.items[l].gstAddOns.length - 1)){
          let tempCessQtyItem = this.items[l].gstAddOns[cessQtyItemIndex];
          this.items[l].gstAddOns.splice(cessQtyItemIndex, 1);
          this.items[l].gstAddOns.push(tempCessQtyItem);
        }

        for(let k=0; k<this.items[l].gstAddOns.length; k++){
          let headerIndex = this.headers.findIndex(header=>{
            return header.gstAddOnsId == this.items[l].gstAddOns[k].addOnsId;
          })

          if(headerIndex==-1 && !this.items[l].gstAddOns[k].cessValueOnQuantity){
            let obj = {};
            obj.gstAddOnsId = this.items[l].gstAddOns[k].addOnsId;
            obj.name = this.items[l].gstAddOns[k].name;

            if((this.getGstColumnType == 3 || this.getGstColumnType == 4) && this.items[l].gstAddOns[k].name != 'CESS'){
              obj.name = 'GST'
            }

            obj.id = 'tableColGST';

            this.headers.push(obj);
          }

          if(headerIndex==-1 && this.items[l].gstAddOns[k].cessValueOnQuantity){
            let obj = {};
            obj.gstAddOnsId = "cessonqty";
            obj.name = "CESS(Qty)";
            obj.id = "tableColGST"
            this.headers.push(obj);
          }
        }

        if(!this.items[l].gstAddOns.length){
          this.hasNilRatedItems = true;
        }

        // calculating custom item fields total
				if(this.items[l].customFields && this.items[l].customFields.length){
					for(let c=0; c<this.items[l].customFields.length; c++){
						let obj = {};
						obj.fieldId = this.items[l].customFields[c].fieldId;
						obj.value = this.items[l].customFields[c].value;
						customFieldsTotal.push(obj);
					}
				}
				
			}

			console.log(JSON.stringify(customFieldsTotal));

			if(customFieldsTotal.length){
				let map = {};
				// group & sum
				customFieldsTotal.forEach(({ fieldId, value }) => {
					if (!map[fieldId]) {
						map[fieldId] = { sum: 0, isValid: true };
					}

					// let num = parseFloat(value);
          let num = Number(value);
					if (isNaN(num)) {
						// if ANY non-number found, invalidate this field
						map[fieldId].isValid = false;
					} else {
						map[fieldId].sum += num;
					}
				});

				// build summary array
				this.customItemFieldsTotal = Object.entries(map).map(([fieldId, info]) => ({
					fieldId,
					value: info.isValid  ? String(info.sum) : "",
				}));
      }

      //removing hsn column from invoice if not mentioned in any invoice
      if(!this.isHsn){
        let hsnHeaderIndex = this.headers.findIndex(head=>{return head.id == 'tableColHsn'});
        this.headers.splice(hsnHeaderIndex, 1);
        // this.headers.splice(2, 1);
        for(let i=0; i<this.items.length; i++){
          delete this.items[i].hsn;
        }
      }

      //removing mrp column from invoice if not mentioned in any invoice
      if(!this.isMrp){
        // let mrpHeaderIndex = this.isHsn ? 4 : 3;
        let mrpHeaderIndex = this.headers.findIndex(head=>{return head.id == 'tableColMrp'});
        // let mrpHeaderIndex = this.isHsn ? 5 : 4;
        this.headers.splice(mrpHeaderIndex, 1);
        for(let i=0; i<this.items.length; i++){
          delete this.items[i].mrp;
        }
        delete this.invoiceFieldsObj.tableColMrp;
      }

      //removing packing column from invoice if not mentioned in any item
      if(!this.isPacking){
        let packingHeaderIndex = this.headers.findIndex(head=>{return head.id == 'tableColPacking'});
        if(packingHeaderIndex != -1){
          this.headers.splice(packingHeaderIndex, 1);
          for(let i=0; i<this.items.length; i++){
            delete this.items[i].packing;
          }
        }
      }

      // this.headers.push({"name":"Taxable Value"});
      // this.headers.push({"name":"Total"});
      this.headers.push({"name":"Total", "id":"tableColTotal"});

      this.headersLength ? this.headersLength(this.headers.length) : '';

      console.log(JSON.stringify(this.headers));
      console.log(JSON.stringify(this.items));
    },

    fn_getFieldTotalValue: function(fieldId){
			for(let i=0; i<this.customItemFieldsTotal.length; i++){
				if(this.customItemFieldsTotal[i].fieldId == fieldId){
					return this.customItemFieldsTotal[i].value; 
				}
			}
		},

    fn_calculateHsnSummary: function(item, addons, dialogToggle){
    // fn_calculateHsnSummary: function(item, gstAddOns, addons){
      // let gstAddOns = addons.filter(addon=>{return addon.isGst});

      // for tax valuation as in gstAddOns total value are separate in this
      let gstAddOnsValues = item.gstAddOns.filter(addon=>{return addon.isGst});

      // for tax naming as in addons total value are combined in this
      let gstAddOns = addons.filter(addon=>{return addon.isGst});

      if(gstAddOns && gstAddOns.length && this.$root.CurrentBusiness.GSTRegistrationStatus == 1){
        let obj = {};
        obj.hsn = item.hsn ? item.hsn : '';
        if(item.batchTotalTaxableValue){
          obj.taxableValue = item.batchTotalTaxableValue;	
        }
        else{
          obj.taxableValue = item.taxableValue;
        }
        // obj.taxableValue = item.taxableValue;

        // obj.gstAddOns =  JSON.parse(JSON.stringify(addons));
        // obj.gstAddOnsValues =  JSON.parse(JSON.stringify(gstAddOnsValues));

        obj.gstAddOns =  JSON.parse(JSON.stringify(gstAddOns));

        let index = obj.gstAddOns.findIndex(inx => {return inx.cessValueOnQuantity})
        if(index != -1){
          let item = obj.gstAddOns.splice(index, 1)[0]; // Remove item from index
          obj.gstAddOns.push(item);                     // Push to end
        }

        obj.totalTax = 0;
        obj.unit = item.unit;

        let isCustomGst = false;
        if(gstAddOnsValues.length == 1 && gstAddOnsValues[0].addOnsId.indexOf("custom_gst") != -1){
          isCustomGst = true;
        }

        if(!isCustomGst && !item.batchLength && obj.gstAddOns.length < 3){
          for(let i=0; i<gstAddOnsValues.length; i++){
            for(let j=0; j<obj.gstAddOns.length; j++){
              if(gstAddOnsValues[i].name == obj.gstAddOns[j].name){
                obj.gstAddOns[j].value = gstAddOnsValues[i].value;
              }
            }
            // obj.totalTax = obj.totalTax + obj.gstAddOnsValues[i].value;
          }
        }

        for(let j=0; j<obj.gstAddOns.length; j++){
          obj.totalTax = obj.totalTax + obj.gstAddOns[j].value;

          let headerIndex = this.hsnSummary.headers.findIndex(header=>{
            return header.id === obj.gstAddOns[j].addOnsId;
          })

          if(headerIndex==-1){
            let hobj = {};
            hobj.id = obj.gstAddOns[j].addOnsId;
            hobj.name = obj.gstAddOns[j].name;

            if(obj.gstAddOns[j].cessValueOnQuantity){
              this.hasCessQty = true;
              hobj.id = 'cessonqty';
              hobj.name = 'CESS(Qty)'
            }

            if(obj.gstAddOns[j].name == 'CESS' && !obj.gstAddOns[j].cessValueOnQuantity){
              this.hasCess = true;
            }

            let cessQtyIndex = this.hsnSummary.headers.findIndex(head=>{return head.name == 'CESS(Qty)'})
            
            if(cessQtyIndex != -1 && hobj.name == 'CESS'){
              this.hsnSummary.headers.splice(cessQtyIndex, 0, hobj);
            }
            else{
              this.hsnSummary.headers.push(hobj);
            }	
            // this.hsnSummary.headers.push(hobj);
          }
        }

        if(!dialogToggle){
          this.hsnSummary.items.push(obj);
        }

        // let gaddons = addons.filter(addon=>{return addon.isGst});
        // for(let i=0; i<gaddons.length; i++){
        // 	let headerIndex = this.hsnSummary.headers.findIndex(header=>{
        // 		return header.id === gaddons[i].addOnsId;
        // 	})

        // 	if(headerIndex==-1){
        // 		let hobj = {};
        // 		hobj.id = gaddons[i].addOnsId;
        // 		hobj.name = gaddons[i].name;

        // 		if(gaddons[i].cessValueOnQuantity){
        // 			hobj.id = 'cessonqty';
        // 			hobj.name = 'Cess on QTY'
        // 		}
        // 		this.hsnSummary.headers.push(hobj);
        // 	}
        // }

        // let customGstAddOns = obj.gstAddOns.filter(addon=>{return addon.addOnsId.indexOf("custom_gst") != -1});
        // if(!customGstAddOns || (customGstAddOns && !customGstAddOns.length)){
        // 	this.hsnSummary.items.push(obj);
        // }

        // if(!this.hsnSummary.items.length){
        // 	if(customGstAddOns && customGstAddOns.length){
        // 		obj.gstAddOns = JSON.parse(JSON.stringify(gaddons));
        // 		this.hsnSummary.items.push(obj);
        // 	}
        // }
      }
    },

    fn_processSummary: function(){
      let totalTax = 0;
      let netTotal = 0;
      let isSimilarGst = true;

      this.addOnsTotal = [];
      this.gstAddOnsTotal = [];
      
      for(let i=0; i<this.items.length; i++){

        netTotal += this.items[i].total;

        for(let j=0; j<this.items[i].addOns.length; j++){

          let addOnsIndex = this.addOnsTotal.findIndex(addOn=>{
            return addOn.addOnsId == this.items[i].addOns[j].addOnsId;
          });

          if(addOnsIndex==-1){
            let obj = {};
            obj.addOnsId = this.items[i].addOns[j].addOnsId;
            obj.name = this.items[i].addOns[j].name;
            obj.value = this.items[i].addOns[j].value;
            this.addOnsTotal.push(obj);
          }
          else{
            this.addOnsTotal[addOnsIndex].value += this.items[i].addOns[j].value;
          }
        }

        for(let k=0; k<this.items[i].gstAddOns.length; k++){

          let addOnsIndex = this.gstAddOnsTotal.findIndex(addOn=>{
            return addOn.gstAddOnsId == this.items[i].gstAddOns[k].addOnsId;
          });

          if(addOnsIndex==-1){
            let obj = {};
            obj.gstAddOnsId = this.items[i].gstAddOns[k].addOnsId;
            obj.name = this.items[i].gstAddOns[k].name;
            obj.value = this.items[i].gstAddOns[k].value;
            this.gstAddOnsTotal.push(obj);
          }
          else{
            this.gstAddOnsTotal[addOnsIndex].value += this.items[i].gstAddOns[k].value;
          }

          totalTax += this.items[i].gstAddOns[k].value;

          if(i>0 && this.itemGstPercentage != this.items[i].gstAddOns[k].percentage){
            isSimilarGst = false;
          }

          this.itemGstPercentage = this.items[i].gstAddOns[k].percentage;

          if(!isSimilarGst){
            this.itemGstPercentage = null;
          }
        }
      }

      // multiplying by the length of gst addons
      // as gstaddons of general print can be single in case of multiple when apply on GST from custom
      if(this.gstAddOnsTotal && this.gstAddOnsTotal.length && this.items[this.items.length - 1].gstAddOnsThermalPrint.length){
        let addonlength = null;

        let cessAddOnIndex = this.gstAddOnsTotal.findIndex(item=>{return item.name == "CESS"});

        if(this.gstAddOnsTotal.length == 1 && this.gstAddOnsTotal[0].gstAddOnsId.indexOf('custom_gst') != -1){
          addonlength = 1;
        }

        if(cessAddOnIndex == -1 && this.items[this.items.length - 1].gstAddOnsThermalPrint.length <= 2){
          !addonlength ? addonlength = this.items[this.items.length - 1].gstAddOnsThermalPrint.length : '';
          this.itemGstPercentage = this.itemGstPercentage * addonlength;
        }
        else{
          this.itemGstPercentage = null;
        }
      }

      this.summary.totalTax = this.roundUpto2Decimals(totalTax);
      this.netTotal = this.roundUpto2Decimals(netTotal);

      if(!this.summary.totalTax){
        let itemIndex = this.headers.findIndex(item=>{return item.name == "Taxable Value"});
        let taxCol = false;
        for(let i=0; i<this.headers.length; i++){
          if(this.headers[i].name == "CGST" || this.headers[i].name == "SGST" || this.headers[i].name == "IGST" || this.headers[i].name == "UTGST" || this.headers[i].name == "CESS" || this.headers[i].name == 'GST'){
            taxCol = true;
          }
        }
        if(!taxCol && itemIndex != -1){
          this.headers.splice(itemIndex, 1);
        }
      }

      console.log(JSON.stringify(this.addOnsTotal));
    },
    
    fn_processSections: function(){
      for(let i=0; i<this.data.templateSettings.printTemplateSections.length; i++){
        let additionalData = this.data.templateSettings.printTemplateSections[i].addData;
        if(this.data.templateSettings.printTemplateSections[i].sectionName == 'header'){
          this.header.data = JSON.parse(additionalData);
          this.header.fieldId = this.data.templateSettings.printTemplateSections[i].fieldId;
          this.header.showInPrintOut = this.data.templateSettings.printTemplateSections[i].status === null ? true : this.data.templateSettings.printTemplateSections[i].status;
        }
        else if(this.data.templateSettings.printTemplateSections[i].sectionName == 'terms'){
          this.terms.data = JSON.parse(additionalData);
          this.terms.fieldId = this.data.templateSettings.printTemplateSections[i].fieldId;
          this.terms.showInPrintOut = this.data.templateSettings.printTemplateSections[i].status === null ? true : this.data.templateSettings.printTemplateSections[i].status;
        }
        else if(this.data.templateSettings.printTemplateSections[i].sectionName == 'printNote'){
            this.printNote.data = JSON.parse(additionalData);
            this.printNote.fieldId = this.data.templateSettings.printTemplateSections[i].fieldId;
            this.printNote.showInPrintOut = this.data.templateSettings.printTemplateSections[i].status === null ? true : this.data.templateSettings.printTemplateSections[i].status;
        }
        else if(this.data.templateSettings.printTemplateSections[i].sectionName == 'bankDetails'){
          this.bankDetails.data = JSON.parse(additionalData);
          this.bankDetails.fieldId = this.data.templateSettings.printTemplateSections[i].fieldId;
          this.bankDetails.showInPrintOut = this.data.templateSettings.printTemplateSections[i].status === null ? true : this.data.templateSettings.printTemplateSections[i].status;
        }
        else if(this.data.templateSettings.printTemplateSections[i].sectionName == 'signature'){

          // if(additionalData){
          //  this.signatory.data = additionalData.indexOf("img") != -1 ?  JSON.parse(additionalData) : null; 
          // }
          // else{
          //  this.signatory.data = null;
          // }
          this.signatory.data = additionalData ?  JSON.parse(additionalData) : null;
          this.signatory.fieldId = this.data.templateSettings.printTemplateSections[i].fieldId;
          this.signatory.showInPrintOut = this.data.templateSettings.printTemplateSections[i].status === null ? true : this.data.templateSettings.printTemplateSections[i].status;
        }
        else if(this.data.templateSettings.printTemplateSections[i].sectionName == 'subtitle'){
          this.subtitle.data = JSON.parse(additionalData);
          this.subtitle.fieldId = this.data.templateSettings.printTemplateSections[i].fieldId;
          this.subtitle.showInPrintOut = this.data.templateSettings.printTemplateSections[i].status === null ? true : this.data.templateSettings.printTemplateSections[i].status;
        }
        else if(this.data.templateSettings.printTemplateSections[i].sectionName == 'billingLabel'){
          this.billingLabel.data = JSON.parse(additionalData);
          this.billingLabel.fieldId = this.data.templateSettings.printTemplateSections[i].fieldId;
          this.billingLabel.showInPrintOut = this.data.templateSettings.printTemplateSections[i].status === null ? true : this.data.templateSettings.printTemplateSections[i].status;
        }
        else if(this.data.templateSettings.printTemplateSections[i].sectionName == 'shippingLabel'){
          this.shippingLabel.data = JSON.parse(additionalData);
          this.shippingLabel.fieldId = this.data.templateSettings.printTemplateSections[i].fieldId;
          this.shippingLabel.showInPrintOut = this.data.templateSettings.printTemplateSections[i].status === null ? true : this.data.templateSettings.printTemplateSections[i].status;
        }
      }

      if(this.data.templateSettings.printFieldLogo){
        this.logoField.fieldId = this.data.templateSettings.printFieldLogo.fieldId;
        this.logoField.showInPrintOut = this.data.templateSettings.printFieldLogo.status;
      }

      if(this.data.templateSettings.printFieldUpiDetail){
        this.upiDetailField.fieldId = this.data.templateSettings.printFieldUpiDetail.fieldId;
        this.upiDetailField.showInPrintOut = this.data.templateSettings.printFieldUpiDetail.status;
      }

      this.$root.fn_getLocalData('bizopslogo_visibility', response=>{
        let val = JSON.parse(response);
        this.brandLogo.showInPrintOut = val === null ? true : val;
      })

      // this.$root.fn_getLocalData('customer_signature_visibility', response=>{
			// 	let val = JSON.parse(response);
      //   this.customerSignature.showInPrintOut = val === null ? true : val;
			// })

      this.$root.fn_getLocalData('item_description', response=>{
        let val = JSON.parse(response);
            this.description.showInPrintOut = val === null ? true : val;
      })

      this.$root.fn_getLocalData('item_itemDescription', response=>{
        let val = JSON.parse(response);
            this.itemDescription.showInPrintOut = val === null ? true : val;
      })

      this.$root.fn_getLocalData('item_category', response=>{
        let val = JSON.parse(response);
            this.category.showInPrintOut = val === null ? false : val;
      })

      this.$root.fn_getLocalData('item_brand', response=>{
        let val = JSON.parse(response);
            this.brand.showInPrintOut = val === null ? false : val;
      })

      this.$root.fn_getLocalData('item_company', response=>{
        let val = JSON.parse(response);
            this.company.showInPrintOut = val === null ? false : val;
      })

      if(this.data.templateSettings.visibilityConfig){
        let visibilityConfig = JSON.parse(this.data.templateSettings.visibilityConfig);
        let hsnSummary = visibilityConfig.filter(config=>{return config.fieldId == 'hsnSummary'});
        if(hsnSummary.length && hsnSummary[0].status){
          this.hasHsnSummary = true;
        }

        let bottomNote = visibilityConfig.filter(config=>{return config.fieldId == 'bottomNote'});
        if(bottomNote.length && bottomNote[0].status){
          this.hasBottomNote = true;
          this.bottomNoteValue = bottomNote[0].value;
        }
      }
    },
    fn_processKeywords: function(templateNo){
      if(this.header.data && this.header.data.content && templateNo == 5){
        this.header.data.content = this.header.data.content.replace(/<p><\/p>/g, '').replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
        this.header.data.content = this.header.data.content.replace(/ql-size-large/g, '');
      }
      this.fn_replaceKeywords(this.header.data);
      this.fn_replaceKeywords(this.terms.data);
      this.fn_replaceKeywords(this.printNote.data);
      this.fn_replaceKeywords(this.bankDetails.data);
      this.fn_replaceKeywords(this.signatory.data);
      this.fn_replaceKeywords(this.subtitle.data);
    },
    fn_replaceKeywords: function(category){
      if(category && category.content){
        category.content = category.content.replaceAll('{{BusinessName}}', this.$root.CurrentBusiness.BusinessName);
        category.content = category.content.replaceAll('{{BusinessAddress}}', this.$root.CurrentBusiness.Address ? this.$root.CurrentBusiness.Address : '');
        category.content = category.content.replaceAll('{{BusinessState}}', this.$root.CurrentBusiness.State ? this.$root.CurrentBusiness.State : '');
        category.content = category.content.replaceAll('{{GSTIN}}', this.$root.CurrentBusiness.GSTNumber ? this.$root.CurrentBusiness.GSTNumber : '');

        if(this.$root.CurrentBusiness.GSTRegistrationStatus == 3){
            category.content = category.content.replaceAll(/GSTIN: /g, '');
        }
      }
    },

    fn_processAccountFields: function(){
      // making invoice config obj for ledger party custom fields
			if(this.data.transactionDetails && this.data.transactionDetails.partyDetails && this.data.transactionDetails.partyDetails.accountFields && this.data.transactionDetails.partyDetails.accountFields.length){
				// itemObj.customFields = itemFields;
				let partyFields = this.data.transactionDetails.partyDetails.accountFields;
				for(let i=0; i<partyFields.length; i++){
					if(partyFields[i].fieldValue){
						let obj = {};
						obj.fieldId = 'party_'+partyFields[i].fieldId;
						obj.fieldName = partyFields[i].fieldName;
						obj.status = true;
						obj.groupName = "PartySection";
						obj.defaultStatus = true;
						obj.partyCustomField = true;
						obj.defaultPositionTableColumn = true;
						obj.positionTableColumn = true;
						if(!this.invoiceFieldsObj[obj.fieldId]){
							this.invoiceFieldsObj[obj.fieldId] = obj;
							this.partyDynamicFields.items.push(obj);
						}
					}
				}								
			}
    },

    fn_showSection: function(showInPrintOut){
      if(this.isEditable){
        return true;
      }
      else{
        if(showInPrintOut){
          return true;
        }
        else{
          return false;
        }
      }
    },

    fn_previousSiblingHeight: function(){
        setTimeout(() => {
            let bottomLeftSection = document.getElementsByClassName("bottom-left-section")[0];
            let bottomRightSection = document.getElementsByClassName("bottom-right-section")[0];
            if(bottomLeftSection.offsetHeight > bottomRightSection.offsetHeight){
                return bottomLeftSection.offsetHeight+'px';
            }
            else{
                return 'auto'
            }
        }, 500);
    },

    fn_toggleField: function(val, fieldId){
      var self = this;
      let dataObj = {};
      dataObj.status = val;
      dataObj.fieldId = fieldId;
      this.postData('TogglePrintFieldVisibility', dataObj, 
        {
          onSuccess: function(response){
                  console.log(response);
                  self.fn_updateFieldStatus(val, fieldId);
              },
              onError: function(error){
                  console.log(error);
              }
        }
          );
    },

    fn_toggleBrandLogo: function(val, fromPreview){
      let dataObj = {};
      dataObj.LocalKey = 'bizopslogo_visibility';
      dataObj.LocalValue = val;
      this.$root.fn_saveLocalData(dataObj);

      fromPreview ? this.brandLogo.showInPrintOut = val : '';
    },

    // fn_toggleCustomerSignature: function(val, fromPreview){
		// 	let dataObj = {};
		// 	dataObj.LocalKey = 'customer_signature_visibility';
		// 	dataObj.LocalValue = val;
		// 	this.$root.fn_saveLocalData(dataObj);
		// 	fromPreview ? this.customerSignature.showInPrintOut = val : '';
		// },

    fn_updateFieldStatus: function(val, fieldId){
      if(this.logoField.fieldId == fieldId){
        this.data.templateSettings.printFieldLogo.status = val;
      }
      else if(this.upiDetailField.fieldId == fieldId){
        this.data.templateSettings.printFieldUpiDetail.status = val;
      }
      else{
        for(let i=0; i<this.data.templateSettings.printTemplateSections.length; i++){
          if(this.data.templateSettings.printTemplateSections[i].fieldId == fieldId){
            this.data.templateSettings.printTemplateSections[i].status = val;
            break;
          }
        } 
      }
    },

    fn_getPlaceOfSupply: function(){
      if(this.data){
        if(this.data.transactionDetails && this.data.transactionDetails.partyDetails && this.data.transactionDetails.partyDetails.stateCode && this.$root.CurrentBusiness.GSTRegistrationStatus != 3){
          return this.data.transactionDetails.partyDetails.placeOfSupply + ' - ' + this.data.transactionDetails.partyDetails.stateCode;
        }
        else{
          return this.data.transactionDetails.partyDetails.placeOfSupply;
        }
      }
      else{
        return '';
      }
    },

    fn_setTableHeaderWidth: function(templateNo, calculateZoomPercent){

      // getting body table width as per template by using template no.
      let bodyTableElement = document.getElementById("body_template_"+templateNo);
      let headerTableElement = document.getElementById("header_template_"+templateNo);
      let waterMarkElement = document.getElementById("page_footer_template_"+templateNo);
      
      if(headerTableElement && bodyTableElement){
        headerTableElement.style.minWidth = bodyTableElement.offsetWidth+'px';  
      }

      if(waterMarkElement && bodyTableElement){
        waterMarkElement.style.minWidth = bodyTableElement.offsetWidth+'px';
      }

      if(this.$route.name != "invoicePreviewSettings"){
        this.dataLoaded = true;
      }

      console.log(calculateZoomPercent);

      this.dataLoaded = true;

      this.fn_descriptionColspanValue();

      // let self = this;
      // if(calculateZoomPercent){
      //   setTimeout(function(){
      //     let header = document.getElementById("header_template_"+templateNo);
      //     if(header){
      //       calculateZoomPercent(header.style.minWidth);  
      //     }
      //   },300);
      // }
      
    },
    // fn_processPrintDetails: function(){
    //  this.printDetails = JSON.parse(this.data.transactionDetails.partyDetails.printDetails);
    // },
    convertNumberToWords: function(amount) {
      // custom addon for paise
          let paise = null;
          let stramount = amount.toString();
          if(stramount.indexOf('.')!=-1){
            paise = stramount.substring(stramount.indexOf('.') + 1);  
          }
          // end of custom addon

        var words = new Array();
        words[0] = '';
        words[1] = 'One';
        words[2] = 'Two';
        words[3] = 'Three';
        words[4] = 'Four';
        words[5] = 'Five';
        words[6] = 'Six';
        words[7] = 'Seven';
        words[8] = 'Eight';
        words[9] = 'Nine';
        words[10] = 'Ten';
        words[11] = 'Eleven';
        words[12] = 'Twelve';
        words[13] = 'Thirteen';
        words[14] = 'Fourteen';
        words[15] = 'Fifteen';
        words[16] = 'Sixteen';
        words[17] = 'Seventeen';
        words[18] = 'Eighteen';
        words[19] = 'Nineteen';
        words[20] = 'Twenty';
        words[30] = 'Thirty';
        words[40] = 'Forty';
        words[50] = 'Fifty';
        words[60] = 'Sixty';
        words[70] = 'Seventy';
        words[80] = 'Eighty';
        words[90] = 'Ninety';
        amount = amount.toString();
        var atemp = amount.split(".");
        var number = atemp[0].split(",").join("");
        var n_length = number.length;
        var words_string = "";
        if (n_length <= 9) {
            var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
            var received_n_array = new Array();
            for (var i = 0; i < n_length; i++) {
                received_n_array[i] = number.substr(i, 1);
            }
            for (var k = 9 - n_length, j = 0; k < 9; k++, j++) {
                n_array[k] = received_n_array[j];
            }
            for (var l = 0, m = 1; l < 9; l++, m++) {
                if (l == 0 || l == 2 || l == 4 || l == 7) {
                    if (n_array[l] == 1) {
                        n_array[m] = 10 + parseInt(n_array[m]);
                        n_array[l] = 0;
                    }
                }
            }
            var value = "";
            for (var n = 0; n < 9; n++) {
                if (n == 0 || n == 2 || n == 4 || n == 7) {
                    value = n_array[n] * 10;
                } else {
                    value = n_array[n];
                }
                if (value != 0) {
                    words_string += words[value] + " ";
                }
                if ((n == 1 && value != 0) || (n == 0 && value != 0 && n_array[n + 1] == 0)) {
                    words_string += "Crores ";
                }
                if ((n == 3 && value != 0) || (n == 2 && value != 0 && n_array[n + 1] == 0)) {
                    words_string += "Lakhs ";
                }
                if ((n == 5 && value != 0) || (n == 4 && value != 0 && n_array[n + 1] == 0)) {
                    words_string += "Thousand ";
                }
                if (n == 6 && value != 0 && (n_array[n + 1] != 0 && n_array[n + 2] != 0)) {
                    words_string += "Hundred and ";
                } else if (n == 6 && value != 0) {
                    words_string += "Hundred ";
                }
            }
            words_string = words_string.split("  ").join(" ");
        }

        if(!paise){
              return words_string;  
          }
          else{
              if(paise.length==1){
                paise = paise + "0";
              }
              
              if(words_string){
                return words_string + 'Rupees and ' + this.convertNumberToWords(paise) + 'Paise';  
              }
              else{
                return '';
              }
          }
        
    },

    fn_footerColspanSize: function(){
      let colSpanSize = 0;
      if(this.filteredItems && this.filteredItems.length){
        // let mrpColSpanSize = 0;
        // if(this.isMrp){
        // 	mrpColSpanSize = this.gstAddOnsTotal.length ? 5 : 4;
        // }
        // else{
        // 	mrpColSpanSize = this.gstAddOnsTotal.length ? 6 : 5;
        // }
        let mrpColSpanSize = this.gstAddOnsTotal.length ? 5 : 4;
        let hsnColpanSize = this.isHsn ? 1 : 0;
        colSpanSize = this.headers.length - this.addOnsTotal.length - this.gstAddOnsTotal.length - mrpColSpanSize - hsnColpanSize - this.fn_customFieldColSize(1);

        let removePack = 0
        if(this.invoiceFieldsObj.tableColPacking && !this.isEditable && this.isPacking){
          removePack =  this.invoiceFieldsObj.tableColPacking && !this.invoiceFieldsObj.tableColPacking.status ? 1 : 0;
        }

        colSpanSize = colSpanSize - removePack;

        if(this.netTotal == 0 && this.gstAddOnsTotal.length && this.fn_showSection(this.invoiceFieldsObj.tableColGST.status)){
          colSpanSize = colSpanSize + 1;
        }

        if(!this.isEditable){
          if(!this.invoiceFieldsObj.tableColRate.status){
            colSpanSize = colSpanSize - 1;
          }
      
          if(!this.invoiceFieldsObj.tableColUnit.status){
            colSpanSize = colSpanSize - 1;
          }
      
          if(this.invoiceFieldsObj.tableColMrp && !this.invoiceFieldsObj.tableColMrp.status){
            colSpanSize = colSpanSize - 1;
          }

          // if(!this.invoiceFieldsObj.tableColTaxableRate.status){
          //   colSpanSize = colSpanSize - 1;
          // }
        }

        if(this.invoiceFieldsObj.tableColPrimaryQty){
          colSpanSize = colSpanSize - 1;
        }

        if(this.invoiceFieldsObj.tableColSecondaryQty){
          colSpanSize = colSpanSize - 1;
        }

        // removing for taxable rate
				colSpanSize = colSpanSize - 1;
      }
      return colSpanSize;
    },

    fn_hsnSummaryColspan: function(){
      let colSpanSize = 0;

      let isIGST = false;
      for(let i=0; i<this.hsnSummary.headers.length; i++){
        if(this.hsnSummary.headers[i].name == 'IGST'){
          isIGST = true;
          break;
        }
      }

      // item table gst colspan size
      let gstColSpanSize = 0;
      if(!this.invoiceFieldsObj.tableColGST.status && !this.isEditable){
        if(this.getGstColumnType == 3 || this.getGstColumnType == 4){
          gstColSpanSize = isIGST ? 1 : 2;
        }
        else{
          gstColSpanSize = isIGST ? 2 : 3;
        }
      }
      if(this.filteredItems && this.filteredItems.length){
        colSpanSize = this.headers.length - this.hsnSummary.headers.length - 2 - gstColSpanSize;

        if(!this.isEditable){
          if(!this.invoiceFieldsObj.tableColRate.status){
            colSpanSize = colSpanSize - 1;
          }
      
          if(!this.invoiceFieldsObj.tableColUnit.status){
            colSpanSize = colSpanSize - 1;
          }
      
          if(this.invoiceFieldsObj.tableColMrp && !this.invoiceFieldsObj.tableColMrp.status){
            colSpanSize = colSpanSize - 1;
          }

          // if(!this.invoiceFieldsObj.tableColTaxableRate.status){
          //   colSpanSize = colSpanSize - 1;
          // }
        }
      }
      return colSpanSize;
    },
    
    fn_formType: function(){
      let transactionListId = this.data.transactionDetails.transactionListId;
      if(transactionListId == 10001 || transactionListId == 10002 || transactionListId == 10003 || transactionListId == 10004 || transactionListId == 10005){
        return 'sale';
      }
      else if(transactionListId == 20001 || transactionListId == 20002 || transactionListId == 20003 || transactionListId == 20004){
        return 'purchase';
      }
      else if(transactionListId == 20005){
        return 'expense';
      }
      else if(transactionListId == 30001 || transactionListId == 30002 || transactionListId == 30003 || transactionListId == 30004 || transactionListId == 30005){
        return 'accountbook';
      }
    },

    showBankDetails: function(){
      let transactionListId = this.data.transactionDetails.transactionListId;
      if(transactionListId == 10002 || transactionListId == 10003 || transactionListId == 10005){
        if(this.isWalkinCustomer && this.$root.TransactionSettings.hideBankDetails){
          return false;
        }
        else{
          return true;
        }
      }
      else{
        return false;
      }
    },

    showBalanceLabel: function(){
      let transactionListId = this.data.transactionDetails.transactionListId;
      if(transactionListId == 10001 || transactionListId == 10002 || transactionListId == 10005 || transactionListId == 20001 || transactionListId == 20002){
        return false;
      }
      else{
        return true;
      }
    },

    showTaxLabels: function(){
      let transactionListId = this.data.transactionDetails.transactionListId;
      if(this.$root.CurrentBusiness && this.$root.CurrentBusiness.GSTRegistrationStatus != 3){
        return true;
      }
      else{
        if(transactionListId == 20001 || transactionListId == 20002 || transactionListId == 20003 || transactionListId == 20004 || transactionListId == 20005){
          return true;
        }
        else{
          return false;
        }
      }
    },

    fn_getToken: function(val){
      if(this.$root.appVersion < 109){
        return;
      }
      // this.showLoading("Please wait...");
      this.$root.fn_getAuthToken(token=>{
        this.fn_brandLogoToServer(val, token);
      });
    },

    fn_brandLogoToServer: function(val, token){
      if(!navigator.onLine){
        // this.showToast('Internet not available');
        return;
      }
      
      // let self = this;
      let dataObj = {};
      dataObj.businessId = this.$root.CurrentBusiness.BusinessID;
      dataObj.token = token;

      let fnName = val ? "EnableLogo" : "RemoveLogo";
      this.getServerData(fnName, dataObj, 
        {
          onSuccess: function(response){
            console.log(response);
            // self.hideLoading();
          }, 
          onError: function(error){
            console.log(error);
            // self.hideLoading();
            // if(typeof JSON.parse(error) == 'object'){
            //   let response = JSON.parse(error);
            //   self.showToast(response.Message);
            // }
          }, 
        }
      );
    },

    fn_previousBalance: function(){

      if(!this.data.transactionDetails.partyDetails.currentBalance){
        return 0;
      }

      let cashTotal = 0;
      if(this.data.transactionDetails.paymentAccounts && this.data.transactionDetails.paymentAccounts.length){
        for(let i=0; i<this.data.transactionDetails.paymentAccounts.length; i++){
          cashTotal = this.roundUpto2Decimals(cashTotal + Math.abs(this.data.transactionDetails.paymentAccounts[i].amount));
        }
      }

      if(this.data.transactionDetails.transactionListId == '10003' || this.data.transactionDetails.transactionListId == '20004'){
        return (this.data.transactionDetails.partyDetails.currentBalance + cashTotal) - this.data.transactionDetails.roundedAmount;
      }

      else if(this.data.transactionDetails.transactionListId == '20003' || this.data.transactionDetails.transactionListId == '20005' || this.data.transactionDetails.transactionListId == '10004'){
        return (this.data.transactionDetails.partyDetails.currentBalance - cashTotal) + this.data.transactionDetails.roundedAmount;
      }
    },

    fn_processListItems: function(){
      if(this.data.transactionDetails.transactionListItemData && this.data.transactionDetails.transactionListItemData.length){
        let prescriberDetails = this.data.transactionDetails.transactionListItemData.filter(item=>{
          return item.listId == 'prescribe_by_details';
        })

        if(prescriberDetails && prescriberDetails.length){
          this.prescriberDetails = {};
          this.prescriberDetails.name = prescriberDetails[0].listItemData.prescribeDetails.name;
          this.prescriberDetails.regNumber = prescriberDetails[0].listItemData.prescribeDetails.regNumber ? prescriberDetails[0].listItemData.prescribeDetails.regNumber : null;
          this.prescriberDetails.mobileNumber = prescriberDetails[0].listItemData.prescribeDetails.mobileNumber ? prescriberDetails[0].listItemData.prescribeDetails.mobileNumber : null;
        }

        let referrerDetails = this.data.transactionDetails.transactionListItemData.filter(item=>{
          return item.listId == 'referred_by_details';
        })

        if(referrerDetails && referrerDetails.length){
          this.referrerDetails = {};
          this.referrerDetails.name = referrerDetails[0].listItemData.referenceDetails.name;
          this.referrerDetails.mobileNumber = referrerDetails[0].listItemData.referenceDetails.mobileNumber ? referrerDetails[0].listItemData.referenceDetails.mobileNumber : null;
        }

        let runningCustomerDetails = this.data.transactionDetails.transactionListItemData.filter(item=>{
          return item.listId == 'running_cash_transaction';
        })

        if(runningCustomerDetails && runningCustomerDetails.length){
          this.isWalkinCustomer = true;
          this.data.transactionDetails.partyDetails.partyName = runningCustomerDetails[0].listItemData.partyName ? runningCustomerDetails[0].listItemData.partyName : 'Cash Sale';	
        }
      }
    },

    fn_customFieldColSize: function(type){
      let customFieldCols = this.headers.filter(header=>{
        return header.fieldId != undefined;
      });
      if(customFieldCols && customFieldCols.length){
        let fieldCount = 0;
        for(let i=0; i<customFieldCols.length; i++){
          if(this.invoiceFieldsObj[customFieldCols[i].fieldId].status){
            fieldCount = fieldCount + 1;
          }
        }

        if(this.isEditable){
          return customFieldCols.length;
        }
        else{
          if(type){
            return customFieldCols.length;
          }
          else{
            return fieldCount;
          }
        }
        // return customFieldCols.length;
      }
      else{
        return 0;
      }
    },

    fn_getItemDetailKey: function(fieldId){
      if(fieldId == 'tableColItemName'){
        return 'itemName';
      }
      else if(fieldId == 'tableColProductCode'){
        return 'productCode';
      }
      else if(fieldId == 'tableColItemDescription'){
        return 'itemDescription';
      }
      else if(fieldId == 'tableColItemNote'){
        return 'description';
      }
      else if(fieldId == 'tableColBrand'){
        return 'brand';
      }
      else if(fieldId == 'tableColCompany'){
        return 'company';
      }
      else if(fieldId == 'tableColCategory'){
        return 'category';
      }
    },

    fn_descriptionColspanValue: function(){
      let spanValue = 1;
      if(this.descriptionColspan == 1 && this.dataLoaded && this.hsnSummary.items.length && this.fn_showSection(this.invoiceFieldsObj.hsnSummary.status)){
        const hsnRow = document.querySelectorAll('.hsn-summary-headers');
        let totalColspan = 0;

        hsnRow[0].querySelectorAll('td').forEach(td => {
          const colspan = parseInt(td.getAttribute('colspan')) || 1;
          let value = colspan > 0 ? colspan : 1;
          totalColspan += value;
        });


        const row = document.querySelectorAll('.items_header');
        let columnCount = 0;

        row[0].querySelectorAll('td').forEach(td => {
          const colspan = parseInt(td.getAttribute('colspan')) || 1;
          columnCount += colspan;
        });

        if(totalColspan > columnCount){
          spanValue = spanValue + (totalColspan - columnCount);
        }
      }
      spanValue > 1 ? this.descriptionColspan = spanValue : '';
    },

    fn_descriptionColspanValue2: function(){
      let spanValue = 1;
      if(this.descriptionColspan == 1 && this.dataLoaded && this.hsnSummary.items && this.hsnSummary.items.length && this.fn_showSection(this.invoiceFieldsObj.hsnSummary.status)){
        const hsnRow = document.querySelectorAll('.hsn-summary-headers');
        let totalColspan = 0;

        hsnRow[0].querySelectorAll('td').forEach(td => {
          const colspan = parseInt(td.getAttribute('colspan')) || 1;
          let value = colspan > 0 ? colspan : 1;
          totalColspan += value;
        });


        const row = document.querySelectorAll('.items_header');
        let columnCount = 0;

        row[3].querySelectorAll('td').forEach(td => {
          const colspan = parseInt(td.getAttribute('colspan')) || 1;
          columnCount += colspan;
        });

        if(totalColspan > columnCount){
          spanValue = spanValue + (totalColspan - columnCount);
        }
      }

      spanValue > 1 ? this.descriptionColspan = spanValue : '';
    },

    fn_hsnSummaryCessQtyEmptyCol: function(index){
      if(this.hasCessQty){
        let cessQtyIndex = this.hsnSummary.items[index].gstAddOns.findIndex(item=>{return item.cessValueOnQuantity});
        if(cessQtyIndex == -1){
          return true;
        }
        else{
          let cessIndex = this.hsnSummary.items[index].gstAddOns.findIndex(item=>{return item.name == 'CESS' && !item.cessValueOnQuantity});
          if(cessIndex == -1 && this.hsnSummary.items.length > 1){
            return true;
          }
          else{
            return false;
          }
          // return false;
        }
      }
      else{
        return false;
      }
    },

    fn_getGlobalIndex: function(groupIndex, itemIndex){
			let count = 0;

			for (let i = 0; i < groupIndex; i++) {
				count += this.filteredItems[i].items.length;
			}

			return count + itemIndex + 1;
		},

    getDueDate: function(){
			let dueIn = this.data.transactionDetails.paymentTerm;
			let transactionDate = this.data.transactionDetails.transactionDate;
			if(dueIn && transactionDate){
				let dueDate = this.$moment(transactionDate).add(dueIn, 'days');
				return this.$moment(dueDate).format(this.$root.TransactionSettings.invoiceDateFormat ? this.$root.TransactionSettings.invoiceDateFormat : 'DD-MMM-YYYY');
			}
			else{
				return '';
			}
		}
  },
  // mounted(){
  //  this.fn_init();
  // },
  computed:{
    filteredItems: function(){
      let transactionGroups = [];

      for(let i in this.items){

        if(this.items[i].baseTransactionNumber != this.data.transactionDetails.transactionNumber){
          this.isRef = true;
        }

            let itemIndex = transactionGroups.findIndex(transItem => transItem.baseTransactionNumber==this.items[i].baseTransactionNumber);

            if(itemIndex!=-1){
                transactionGroups[itemIndex].items.push(this.items[i]);
            }
            else{
                let obj = {};
                obj.baseTransactionNumber = this.items[i].baseTransactionNumber;
                obj.items = []
                obj.items.push(this.items[i]);
                transactionGroups.push(obj);
            }
        }

        console.log(JSON.stringify(transactionGroups));

        return transactionGroups;
    },
    roundOffAmount: function(){
      if(this.data.transactionDetails.roundOffValue){
        return this.data.transactionDetails.roundOffValue;
      }
      else{
        if(this.data.transactionDetails.isRounded){
          return this.roundUpto2Decimals(this.data.transactionDetails.roundedAmount - this.data.transactionDetails.amount);
        }
        else{
          return 0;
        }
      }
    },
    invoiceColor: function(){
      if(this.themeColor){
        return this.themeColor;
      }
      else{
        return this.data.templateSettings.themeColor;
      }
    },
    getGridClass: function(){
      if(this.gridClass != undefined){
        return this.gridClass;
      }
      else if(this.gridClassValue){
        return this.gridClassValue;
      }
      else{
        return 'nogrid';
      }
    },
    footerSectionStyle: function(){
      if(this.footerSection != undefined){
        return this.footerSection;
      }
      else if(this.footerSectionValue){
        return this.footerSectionValue;
      }
      else{
        return 1;
      }
    },
    getGstColumnType: function(){
      if(this.gstColumnType != undefined){
        return this.gstColumnType;
      }
      else if(this.gstColumnTypeValue){
        return this.gstColumnTypeValue;
      }
      else{
        return 2;
      }
    },
    otherFieldsPosValue: function(){
      if(this.otherFieldsPos != undefined){
        return this.otherFieldsPos;
      }
      else if(this.otherFieldsPosition){
        return this.otherFieldsPosition;
      }
      else{
        return 1;
      }
    },
    hasFooterSection: function(){
      let hasTerms = this.invoiceFieldsObj.terms.status && this.terms.data && this.terms.data.content;
      let hasPrintNote = this.invoiceFieldsObj.printNote.status && this.invoiceFieldsObj.printNote.value;
      let hasUPIDetails = this.invoiceFieldsObj.upiDetails.status && this.$root.CurrentBusiness.UpiID && this.showBankDetails();
      let hasBankDetails = this.invoiceFieldsObj.bankDetails.status && this.bankDetails.data && this.bankDetails.data.content && this.showBankDetails();
      let hasSignature = this.invoiceFieldsObj.signatory.status && this.signatory.data && this.signatory.data.content;
      let hasBrandLogo = this.brandLogo.showInPrintOut;
      let customerSignature = this.invoiceFieldsObj.customerSignature.status && this.$root.TransactionSettings.enableCustomerSignature;
      return hasTerms || hasPrintNote || hasUPIDetails || hasBankDetails || hasSignature || hasBrandLogo || customerSignature || this.isEditable;
    }
  }
}